<template lang="pug">

  div
    MFlashMessages
    div( v-if="loading || $apollo.loading" ) Loading...
    div( v-else )

      template( v-if="showOldAuditModal" )
        div( class="modal-backdrop fade show" style="display: block;" )
        div( class="modal inmodal fade show" style="display: block;" v-on:click.self="showOldAuditModal = false" )
          div( class="modal-dialog modal-lg" )
            div( class="modal-content" )
              div( class="modal-header" )
                button( type="button" class="close" v-on:click="showOldAuditModal = false" ) &times;
                h4( class="modal-title" ) Audit out of date
              div( class="modal-body" )
                p This audit is more than 7 days old. Please rerun the link using the Callisto platform to access a report.
                p Your login details remain the same, and the platform is accessed at&nbsp;
                  a( href="https://callisto.mnll.com" target="_blank" ) callisto.mnll.com

      div( v-if="! pdfBtn" )
        div( class="row mt-4 custom-title" )
          div( class="col-md-8" )
            h2(
              v-bind:class="{ 'page-title': true, 'mt-4': !hasLinks, 'mt-3': hasLinks }"
            ) {{ getAdvertiserName(auditData) }}

            p( class="link-audited mb-0" )
              strong Link audited:&nbsp;
              a( target="_blank" v-bind:href="auditData.link" ) {{ auditData.link.substr(0, 100) }}{{ (auditData.link.length > 100) ? '...' : '' }}
              
            p( v-if="auditData.batchLink && auditData.batchLink.postAlpURL" class="link-audited mb-0" )
              strong Alternative URL specified:&nbsp;
              a( target="_blank" v-bind:href="auditData.batchLink.postAlpURL" ) {{ auditData.batchLink.postAlpURL.substr(0, 100) }}{{ (auditData.batchLink.postAlpURL.length > 100) ? '...' : '' }}

            p( class="mb-0" )
              strong Audited at:&nbsp;
              | {{ dateFormat(auditData.auditedAt, 'dS mmmm yyyy') }}
            p( v-if="$moonpull.currentUserIsSuperAdmin()" class="mb-0" )
              strong Company:&nbsp;
              | {{ auditData.batch.owner.company.name }}

            p( class="mb-0" )
              router-link( class="d-block" v-bind:to="`/reporting/audits/${$route.params.auditId}/technical-report`" ) View Moonpull Technical Report
            
            div( v-if="$moonpull.currentUserHasAccessTo('moonpullLiteReport')" )
              p
                router-link(
                  v-if="auditData.webUnlockerRequestId"
                  v-bind:to="`/reporting/audits/${auditData.id}/lite-results`"
                )
                  | View Moonpull Lite Results
            div( v-if="$moonpull.currentUserIsSuperAdmin()" )
              p
                MMoonpullIcon( class="mr-2" )
                strong Issue Reporting debug info:&nbsp;
                a( v-on:click.prevent="showIssueReportDebugInfo = ! showIssueReportDebugInfo" href="#" )
                  | {{ showIssueReportDebugInfo ? 'Hide' : 'Show' }}

              div( class="ibox" v-if="showIssueReportDebugInfo" )
                div( class="ibox-content" )
                  table
                    tbody
                      tr( v-for="(value, key) in getIssueReportDebugInfo()" )
                        td( class="text-left" ) {{ key }}
                        td {{ value }}

            p( v-if="isReportable && $moonpull.currentUserHasShareAccess()" )
              MReportIssueButton(
                v-bind:audit-id="auditData.id"
                v-bind:advertiser-id="auditData.advertiser.id"
              )

            p(v-if="isAuditedRecently")
              button(
                id="moonpull-local-memory-cookie-check-btn"
                class="btn btn-primary d-none"
                v-on:click="localMemoryCookieCheck"
                v-bind:disabled="loadingLocalMemoryCookieCheck"
              )
                span(v-if="loadingLocalMemoryCookieCheck") Working...
                span(v-else) Run Browser Extension

            p( v-else )
              MModalButton(
                title="Browser Extension"
                button-classes="btn btn-primary"
                modal-size="modal-lg"
              )
                span( slot="button-inner" ) Run Browser Extension
                div( slot="body" )
                  p This audit is over 8 days old and should be rerun in Moonpull to check for any status changes.
                  p Please click the “Rerun Link” button below to get an up-to-date status for this audit.
                  button( 
                    class="btn btn-primary"
                    v-on:click="rerunLinkAndBrowserExtension"
                    v-if="$moonpull.currentUserIsSuperAdmin() || $moonpull.currentUserHasAccessTo('rerunLinkAndBrowserExtension')"
                  )
                    | Rerun link &amp; launch browser extension

            
            p( v-if="$moonpull.currentUserIsSuperAdmin()" )
              button( class="btn btn-primary" v-on:click="onLiteSubmit" v-bind:disabled="loadingLite" )
                MMoonpullIcon( class="mr-2" )
                | Update with Lite
            p
              button( class="btn btn-primary" v-on:click="yourAuditNavigation" )
                | See Advertiser Audits

            MModalButton(
              v-if="$moonpull.currentUserIsSuperAdmin()"
              title="Google Gemini CMP"
              subtitle="Analyse the CMP images of this advertiser using Google Gemini"
              button-classes="btn btn-primary"
              modal-size="modal-lg"
              v-on:onModalShow="loadAiInteractions"
            )
              span( slot="button-inner" )
                MMoonpullIcon( class="mr-2" )
                | Google Gemini CMP
              div( slot="body" )
                p
                  strong Gemini prompt:
                textarea(
                  class="form-control w-100"
                  name="geminiPrompt"
                  label="Google Gemini Prompt"
                  rows="10"
                  v-model="geminiCmpPrompt"
                )
                div( v-if="geminiCmpResponse !== null")
                  p(class="mt-4 mb-0")
                    strong Gemini Response:
                  div(v-html="geminiCmpResponse" class="p-2 mt-4 border")
                button(
                  v-on:click="submitGeminiPrompt"
                  v-bind:disabled="geminiLoading"
                  class="btn btn-primary mt-3"
                )
                  span( v-if="geminiLoading" ) Working...
                  span( v-else ) Analyse
            
            MMemoryCookieAlerts( v-bind:audit="auditData" v-on:showPlatformResult="showPlatformResult" )

            div( class="alert alert-secondary text-center mt-4" v-if="isUnsupportedNetwork" )
              | {{ auditData.network }} is not currently supported. Please contact Moonpull for more information.

            div(v-if="auditData.advertiser && auditData.advertiser.publicComment")
              div(class="alert alert-info text-center")
                p(style="white-space:pre-line; margin:0") {{ auditData.advertiser.publicComment }}


            div(
              class="alert alert-warning text-center"
              v-if="$moonpull.currentUserHasShareAccess() && auditData.advertiser && auditData.advertiser.issueCount > 0"
            )
              div( v-if="auditData.advertiser.issueCount > 0" )
                | {{ auditData.advertiser.issueCount }} outstanding issue(s) from
                |  {{ auditData.advertiser.issueReportCount }} publisher(s) for this advertiser

          div( class="col-md-4" )
            div( class="ibox" )
              div( class="ibox-content" )
                div( class="crawled-score" )
                  strong Audit Highlights
                  MAuditBadges( v-bind:audit="auditData" wrap center )
                  
                  hr
                  strong First Party Tracking:
                  MMemoryCookieStatusBadges( v-bind:audit="auditData" )
                  
                  template( v-if="wasThirdPartyDetected()" )
                    hr
                    strong Third party:&nbsp;
                    span {{ wasThirdPartyDetected() }}
                  hr
                  
                  template(v-if="$moonpull.currentUserIsSuperAdmin()")
                    MMoonpullIcon( class="mr-2" )
                    strong BE Review Comment
                    br
                    input(
                      class="form-control mt-2"
                      type="textarea"
                      v-model="auditData.reviewedComment"
                      label="BE Reviewed Comment"
                    )
                    br
                    MMoonpullIcon( class="mr-2" )
                    strong BE Review Status
                    br
                    select( class="form-control mt-2" v-model="auditData.reviewedStatus")
                      option(
                        v-for="(label, value) in readableCsStatus"
                        :key="value"
                        :value="value"
                      ) {{ label }}
                    div.text-right
                      button.btn.btn-primary.mt-2.text-right(
                        v-on:click="updateReviewStatus"
                      ) Update

                  template( v-if="isAuditDataOld" )
                    hr
                    div( class="alert alert-warning text-center" )
                      strong This audit is older than 7 days, please consider rerunning the audit for more accurate data.

        div( class="wrapper wrapper-content" )

          div( class="back-page" )
            router-link(
              v-bind:to="batchLink"
            )
              i( class="fa fa-angle-left" )
              | &nbsp;Back to Batch

          div( class="mb-4" )

            div( v-if="editingStatusAndAssignment" )
              span Status:
              MEntityChildUpdate(
                entity="audit"
                child="status"
                child-sort="{ order: ASC }"
                v-bind:child-fields="[ 'order', 'narrative' ]"
                v-bind:object="auditData"
                object-child-field="assessmentStatus"
                v-slot="{ child: { order, narrative } }"
              ) {{ narrative }}

              span Link Owner:
              MEntityChildUpdate(
                entity="audit"
                child="user"
                v-bind:child-fields="[ 'name', 'email' ]"
                v-bind:object="auditData"
                object-child-field="assignedTo"
                v-slot="{ child: { name, email } }"
              ) {{ name }}

              span( class="inline-block mx-2" ) (last updated {{ dateFormat(auditData.updatedAt, 'dd/mm/yy, HH:MM') }})

              a( href="#" v-on:click.prevent="editingStatusAndAssignment = false" ) Save

            div( v-else )
              div( class="row")
                div( class="col-md-6" )
                  span( class="inline-block" v-if="$moonpull.currentUserHasAccessTo('geekFeatures')" )
                    | Status:&nbsp;
                    strong {{ (auditData.assessmentStatus && auditData.assessmentStatus.narrative) || 'No status assigned' }}

                  span( class="inline-block mx-4" v-if="$moonpull.currentUserHasAccessTo('geekFeatures')" )
                    | Link Owner:&nbsp;
                    strong {{ (auditData.assignedTo && `${auditData.assignedTo.name}`) || 'Not yet assigned' }}

                  a( v-if="$moonpull.currentUserHasAccessTo('geekFeatures')" href="#" v-on:click.prevent="editingStatusAndAssignment = true" )
                    i( class="fa fa-pencil" )

                div( class="col-md-6 text-right" )
                  
                  div(class="btn-group")
                    MModalButton(
                      button-classes="btn btn-details btn-outline btn-info mr-2"
                      title="Rerun Link"
                      modal-size="modal-xl"
                    )
                      span( slot="button-inner" )
                        | Rerun link
                      div( slot="body" )
                        div( class="text-center" )
                          span If an audit is inconsistent, we recommend testing it at least three times.
                          br
                          span If verifying a resolved tracking issue, a single test should suffice.
                          br
                          span Repeat requests will run at the chosen time separation.
                          br
                          span Please note, these audits count toward your monthly allowance.
                        MForm( 
                          v-on:submit="submitLinkMultipleTimes"
                          v-bind:disabled="loadingMultipleLinkSubmission"
                          v-bind:submit-text="loadingMultipleLinkSubmission ? 'Submitting...' : 'Submit'" 
                        )
                          MInput(
                            name="numRuns"
                            label="Number of runs"
                            type="number"
                            value="1"
                            )
                          MInput(
                          :value="data.delay !== undefined ? data.delay : delayOptions[0].value"
                          @update:value="val => data.delay = Number(val)"
                          type="select"
                          name="delay"
                          label="Time between audits"
                          :options="delayOptions"
                          )

                    button(
                      class="btn btn-details btn-outline btn-info mr-2"
                      v-on:click="submitConsentAnalysis"
                      v-if="shouldShowConsentChecker()"
                    )
                      | Consent Checker (Beta)
                    MModalButton(
                      title="Consent Checker (Beta)"
                      button-classes="btn btn-details btn-outline btn-info mr-2"
                      modal-size="modal-xl"
                      v-if="shouldShowConsentModal()"
                    )
                      span( slot="button-inner" )
                        | Consent Checker (Beta)
                      div( slot="body" )
                        p( class="text-center" ) As this link was completed using Moonpull Lite the Consent Checker is unavailable.
                    
                    template( v-if="auditData.assessmentStatus || auditData.enhancedMemoryCookieStatuses[0]" )
                      div( v-if="(shouldShowupliftcalcImmediate())")
                        MModalButton(
                          title="Tested ok - no CMP"
                          button-classes="btn btn-details btn-outline btn-info"
                          modal-size="modal-xl"
                          class="value-calculator-success mr-2"
                          v-on:onModalShow="resetCalculator"
                        )
                          span( slot="button-inner" )
                            | Uplift Calculator
                          div( slot="body" )
                            p First party tracking is always present for this landing page regardless of user consent.  Therefore no uplift for tracking issues to calculate.

                      div( v-else-if="(shouldShowupliftcalcImmediate())")
                        MModalButton(
                          title="Tested ok - CMP Engaged"
                          button-classes="btn btn-details btn-outline btn-info"
                          modal-size="modal-xl"
                          class="value-calculator-success mr-2"
                          v-on:onModalShow="resetCalculator"
                        )
                          span( slot="button-inner" )
                              | Uplift Calculator
                          div( slot="body" )
                            p First party tracking is always present for this landing page regardless of user consent.  Therefore no uplift for tracking issues to calculate.
                      div( v-else-if="auditData.closedMerchant" )
                        MModalButton(
                          title="Closed"
                          button-classes="btn btn-details btn-outline btn-info"
                          modal-size="modal-xl"
                          v-on:onModalShow="resetCalculator"
                        )
                          span( slot="button-inner" )
                              | Uplift Calculator
                          div( slot="body" )
                            p The Advertiser's program is closed.
                      div( v-else-if="(shouldShowupliftcalcImmediate())")
                        MModalButton(
                          title="First party tracking successfully initiated."
                          button-classes="btn btn-details btn-outline btn-info"
                          modal-size="modal-xl"
                          class="value-calculator-success mr-2"
                          v-on:onModalShow="resetCalculator"
                        )
                          span( slot="button-inner" )
                            | Uplift Calculator
                          div( slot="body" )
                            p First party tracking is always present for this landing page regardless of user consent. Therefore no uplift for tracking issues to calculate.
                      div(v-else-if="isWarningScenario()")
                        MModalButton(
                          title="Potential performance increase with optimised tracking. First party tracking subject to user consent."
                          button-classes="btn btn-details btn-outline btn-info"
                          modal-size="modal-xl"
                          class="value-calculator mr-2"
                          v-on:onModalShow="resetCalculator"
                        )
                          span(slot="button-inner")
                            | Uplift Calculator
                          div(slot="body")
                            div(v-if="downloadingValueCalc")
                              p Downloading...
                              p(class="text-right")
                                button(class="btn btn-secondary" v-on:click="closeSendMailModal") Close
                            MForm(v-on:submit="downloadWarningScenarioCalc" submit-text="Download Uplift Calculator")
                              div(class="row")
                                div(class="col-sm-4")
                                  span Advertiser:&nbsp;
                                  h3 {{ getAdvertiserName(auditData) }}
                                div(class="col-sm-4")
                                  span Network:&nbsp;
                                  h3 {{ auditData.network }}
                                div(class="col-sm-4")
                                  span Country:&nbsp;
                                  h3 {{ (auditData.proxyDetails && auditData.proxyDetails.country) || 'N/A' }}
                              hr
                              div(class="row")
                                div(class="col-sm-6")
                                  h3 Inputs for calculation
                                  div(class="row mt-3")
                                    div(class="col-sm-6")
                                      span Currency Symbol
                                    div(class="col-sm-6")
                                      input(
                                        name="currencysymbol"
                                        label="Currency Symbol"
                                        type="text"
                                        v-model="data.currencySymbol"
                                      )
                                  div(class="row mt-3")
                                    div(class="col-sm-6")
                                      span Average basket size
                                    div(class="col-sm-6")
                                      input(
                                        name="avgbasket"
                                        label="Average basket size"
                                        type="number"
                                        v-model="data.avgBasket"
                                      )
                                  div(class="row mt-3")
                                    div(class="col-sm-6")
                                      span Monthly tracked sales
                                    div(class="col-sm-6")
                                      input(
                                        name="monthlytrackedsales"
                                        label="Monthly tracked sales"
                                        type="number"
                                        v-model="data.monthlyTrackedSales"
                                      )
                                  div(class="row mt-3 mb-4")
                                    div(class="col-sm-6")
                                      span Ave commission %
                                    div(class="col-sm-6")
                                      input(
                                        name="avecommission"
                                        label="Ave commission %"
                                        type="number"
                                        v-model.number="data.aveCommission"
                                      )
                                  h3 User profile
                                  div(class="row mt-3")
                                    div(class="col-sm-6")
                                      span Users with browsers accepting third party tracking (%)
                                    div(class="col-sm-6")
                                      input(
                                        class="mt-2"
                                        name="proportionofusers"
                                        label="Proportion of users with their browser accepting third party cookies (e.g Chrome) or your alternative method"
                                        type="number"
                                        min="1"
                                        max="99"
                                        v-model="data.proportionOfUsers"
                                      )
                                  div(class="row mt-3")
                                    div(class="col-sm-6")
                                      span Users granting consent (%)
                                    div(class="col-sm-6")
                                      input(
                                        class="mt-2"
                                        name="proportionconsent"
                                        label="Proportion of your users giving their consent to cookies and tracking"
                                        type="number"
                                        min="1"
                                        max="99"
                                        v-model="data.proportionConsent"
                                      )
                                  button(
                                    type="button"
                                    v-on:click="valueCalculator(auditData)"
                                    class="btn btn-details btn-primary mt-4 p-2"
                                  ) Calculate
                                div(class="col-sm-6")
                                  h3 Affiliate channel performance
                                  p Based on the input data
                                  div(class="row")
                                    div(class="col-sm-8 mt-2")
                                      span() Monthly sales value tracked
                                    div(class="col-sm-4 mt-2")
                                      span(class="result") {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.monthlySalesValue) }}
                                  div(class="row")
                                    div(class="col-sm-8 mt-3")
                                      span() Commission payable
                                    div(class="col-sm-4 mt-3")
                                      span(class="result") {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.commissionPayable) }}
                                  hr
                                  h3 If all referrals were being tracked
                                  p Assumes 100% user consent where needed
                                  div(class="row")
                                    div(class="col-sm-8 mt-2")
                                      span Estimated actual sales value
                                    div(class="col-sm-4 mt-2")
                                      span(class="result") {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.improvedMonthlySalesValue) }}
                                  div(class="row")
                                    div(class="col-sm-8 mt-3")
                                      span Commission payable
                                    div(class="col-sm-4 mt-3")
                                      span(class="result") {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.improvedCommission) }}
                                  hr
                                  div(class="row")
                                    div(class="col-sm-8 mt-2")
                                      h2 Overall Improvement
                                    div(class="col-sm-4 mt-2")
                                      h2 {{ data.overalImprovement }}%

                      div( v-else-if="isWarningScenarioRefresh()" )
                        MModalButton(
                          title="Potential performance increase with optimised tracking. First party tracking subject to user consent."
                          subtitle="We recommend you check to see if the 'refresh stage' requires a URL including the network's ANI or  merely navigation to another page.  In most cases the Consent Checker can be used for this purpose."
                          button-classes="btn btn-details btn-outline btn-info"
                          modal-size="modal-xl"
                          class="value-calculator mr-2"
                          v-on:onModalShow="resetCalculator"
                        )
                          span( slot="button-inner" )
                            | Uplift Calculator
                          div( slot="body" )
                            div( v-if="downloadingValueCalc" )
                              p Downloading...
                              p( class="text-right" )
                                button( class="btn btn-secondary" v-on:click="closeSendMailModal" ) Close
                            MForm( v-on:submit="downloadWarningScenarioCalc" submit-text="Download Uplift Calculator" )
                              div( class="row" )
                                div( class="col-sm-4" )
                                  span Advertiser:&nbsp;
                                  h3 {{ getAdvertiserName(auditData) }}  
                                div( class="col-sm-4" )
                                  span Network:&nbsp;
                                  h3 {{ auditData.network }}
                                div( class="col-sm-4" )
                                  span Country:&nbsp;
                                  h3 {{ (auditData.proxyDetails && auditData.proxyDetails.country) || 'N/A' }}
                              hr
                              div( class="row" )
                                div( class="col-sm-6" )
                                  h3 Inputs for calculation
                                  div( class="row mt-3")
                                    div( class="col-sm-6" )
                                      span Currency Symbol
                                    div( class="col-sm-6" )
                                      input(
                                        name="currencysymbol"
                                        label="Curreny Symbol"
                                        type="text"
                                        v-model="data.currencySymbol"
                                      )
                                  div( class="row mt-3")
                                    div( class="col-sm-6" )
                                      span Average basket size
                                    div( class="col-sm-6" )
                                      input(
                                        name="avgbasket"
                                        label="Average basket size"
                                        type="number"
                                        v-model="data.avgBasket"
                                      )
                                  div( class="row mt-3")
                                    div( class="col-sm-6" )
                                      span Monthly tracked sales
                                    div( class="col-sm-6" )
                                      input(
                                        name="monthlytrackedsales"
                                        label="Monthly tracked sales"
                                        type="number"
                                        v-model="data.monthlyTrackedSales"
                                      )
                                  div( class="row mt-3 mb-4")
                                    div( class="col-sm-6" )
                                      span Ave commission %
                                    div( class="col-sm-6" )
                                      input(
                                        name="avecommission"
                                        label="Ave commission %"
                                        type="number"
                                        v-model.number="data.aveCommission"
                                      )
                                  h3 User profile
                                  div( class="row mt-3")
                                    div( class="col-sm-6" )
                                      span Users with browsers accepting third party tracking (%)
                                    div( class="col-sm-6" )
                                      input(
                                        class="mt-2"
                                        name="proportionofusers"
                                        label="Proportion of users with their browser accepting third part cookies (e.g Chrome) or your alternative method"
                                        type="number"
                                        min="1"
                                        max="99"
                                        v-model="data.proportionOfUsers"
                                      )
                                  div( class="row mt-3")
                                      div( class="col-sm-6" )
                                        span Users granting consent (%)
                                      div( class="col-sm-6" )
                                        input(
                                          class="mt-2"
                                          name="proportionconsent"
                                          label="Proportion of your users giving their consent to cookies and tracking"
                                          type="number"
                                          min="1"
                                          max="99"
                                          v-model="data.proportionConsent"
                                        )
                                  button(
                                    type="button"
                                    v-on:click="valueCalculator(auditData)"
                                    class="btn btn-details btn-primary mt-4 p-2"
                                  ) Calculate
                                div( class="col-sm-6" )
                                  h3 Affiliate channel performance
                                  p Based on the input data
                                  div( class="row" )
                                    div( class="col-sm-8 mt-2" )
                                      span() Monthly sales value tracked
                                    div( class="col-sm-4 mt-2")
                                      span( class="result" ) {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.monthlySalesValue) }}
                                  div( class="row" )
                                    div( class="col-sm-8 mt-3" )
                                      span( ) Commission payable
                                    div( class="col-sm-4 mt-3")
                                      span( class="result" ) {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.commissionPayable)  }}
                                  hr
                                  h3 If all referrals were being tracked
                                  p Assumes 100% user consent where needed
                                  div( class="row" )
                                    div( class="col-sm-8 mt-2" )
                                      span Estimated actual sales value
                                    div( class="col-sm-4 mt-2")
                                      span( class="result" ) {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.improvedMonthlySalesValue) }}
                                  div( class="row" )
                                    div( class="col-sm-8 mt-3" )
                                      span Commission payable
                                    div( class="col-sm-4 mt-3")
                                      span( class="result" ) {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.improvedCommission) }}
                                  hr
                                  div( class="row" )
                                    div( class="col-sm-8 mt-2" )
                                      h2 Overall Improvement
                                    div( class="col-sm-4 mt-2")
                                      h2 {{ data.overalImprovement }}%
  
                      div( v-else-if="(shouldShowUpliftcalcNoCookie())" )
                        MModalButton(
                          title="Illustration of performance - third party only"
                          button-classes="btn btn-details btn-outline btn-info"
                          modal-size="modal-xl"
                          class="value-calculator mr-2"
                          v-on:onModalShow="resetCalculator"
                        )
                          span( slot="button-inner" )
                            | Uplift Calculator
                          div( slot="body" )
                            div( v-if="downloadingValueCalc" )
                              p Downloading...
                              p( class="text-right" )
                                button( class="btn btn-secondary" v-on:click="closeSendMailModal" ) Close
                            MForm( submit-text="Download Uplift Calculator" v-on:submit="downloadValueCalc" )
                              div( class="row" )
                                div( class="col-sm-4" )
                                  span Advertiser:&nbsp;
                                  h3 {{ auditData.finalDomain }}
                                div( class="col-sm-4" )
                                  span Network:&nbsp;
                                  h3 {{ auditData.network }}
                                div( class="col-sm-4" )
                                  span Country:&nbsp;
                                  h3 {{ (auditData.proxyDetails && auditData.proxyDetails.country) || 'N/A' }}
                              hr
                              div( class="row" )
                                div( class="col-sm-6" )
                                  h3 Inputs for calculation
                                  div( class="row" )
                                    div( class="col-sm-6" )
                                      span Currency Symbol
                                    div( class="col-sm-6" )
                                      input(
                                        class="mt-2"
                                        name="currencysymbol"
                                        label="Currency Symbol"
                                        type="text"
                                        v-model="data.currencySymbol"
                                      )
                                  div( class="row" )
                                    div( class="col-sm-6" )
                                      span Average basket size
                                    div( class="col-sm-6" )
                                      input(
                                        class="mt-2"
                                        name="avgbasket"
                                        label="Average basket size"
                                        type="number"
                                        v-model="data.avgBasket"
                                      )
                                  div( class="row" )
                                    div( class="col-sm-6" )
                                      span Monthly tracked sales
                                    div( class="col-sm-6" )
                                      input(
                                        class="mt-2"
                                        name="monthlytrackedsales"
                                        label="Monthly tracked sales"
                                        type="number"
                                        v-model="data.monthlyTrackedSales"
                                      )
                                  div( class="row" )
                                    div( class="col-sm-6" )
                                      span Ave commission %
                                    div( class="col-sm-6" )
                                      input(
                                        class="mt-2"
                                        name="avecommission"
                                        label="Ave commission %"
                                        type="number"
                                        v-model.number="data.aveCommission"
                                      )
                                  h3 User profile
                                  div( class="row" )
                                    div( class="col-sm-6" )
                                      span Users with browsers accepting
                                      br
                                      span third party tracking (%)
                                    div( class="col-sm-6" )
                                      input(
                                        class="mt-2"
                                        name="proportionofusers"
                                        label="Proportion of users with their browser accepting third party cookies"
                                        type="number"
                                        v-model="data.proportionOfUsers"
                                      )
                                  div( class="row mt-2" )
                                    div( class="col-sm-6" )
                                      span Users granting consent (%)
                                    div( class="col-sm-6" )
                                      input(
                                        class="mt-2"
                                        name="proportionconsent"
                                        label="Proportion of your users giving their consent"
                                        type="number"
                                        v-model="data.proportionConsentCalc2"
                                      )
                                  button(
                                    type="button"
                                    v-on:click="valueCalculator(auditData)"
                                    class="btn btn-details btn-primary mt-4 p-2"
                                  ) Calculate

                                div( class="col-sm-6" )
                                  h3 Affiliate channel performance
                                  p Based on the input data
                                  div( class="row" )
                                    div( class="col-sm-8 mt-4" )
                                      span() Monthly sales value tracked
                                    div( class="col-sm-4 mt-4")
                                      span {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.monthlySalesValue) }}
                                  div( class="row" )
                                    div( class="col-sm-8 mt-4" )
                                      span( ) Commission payable
                                    div( class="col-sm-4 mt-4")
                                      span {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.commissionPayable)  }}
                                  hr
                                  h3 If all referrals were being tracked
                                  p Assumes 100% user consent where needed
                                  div( class="row" )
                                    div( class="col-sm-8 mt-4" )
                                      span Estimated actual sales value
                                    div( class="col-sm-4 mt-4") 
                                      span {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.improvedMonthlySalesValue) }}
                                  div( class="row" )
                                    div( class="col-sm-8 mt-4" )
                                      span Commission payable
                                    div( class="col-sm-4 mt-4") 
                                      span {{ data.currencySymbol }} {{ Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(data.improvedCommission) }}
                                  hr
                                  div( class="row" )
                                    div( class="col-sm-8 mt-4" )
                                      h2 Overall Improvement
                                    div( class="col-sm-4 mt-4") 
                                      h2 {{ data.overalImprovement }}%
                      div( v-else-if="auditData.manualReviewRequired" )
                        MModalButton(
                          title="Manual Review"
                          button-classes="btn btn-details btn-outline btn-info"
                          modal-size="modal-xl"
                          class="value-calculator mr-2"
                          v-on:onModalShow="resetCalculator"
                        )
                          span( slot="button-inner" )
                            | Uplift Calculator
                          div( slot="body" )
                            p This is a complex scenario. The implications of the cause of this being flagged for Manual Review need to be appraised individually.
                  div(class="btn-group")
                    MModalButton(
                      v-bind:button-text="'Contact Moonpull'"
                      title="Discuss issues about this audit with the Moonpull Client service team"
                      button-classes="btn btn-details btn-outline btn-info"
                      modal-size="modal-lg"
                    )
                      div( slot="body" )
                        div( v-if="sendMailSuccessful" )
                          p Your CMP request was successfully sent.
                          p( class="text-right" )
                            button( class="btn btn-secondary" v-on:click="closeSendMailModal" ) Close
                        MForm( v-else v-on:submit="sendMail" submit-text="Send" )
                          MInput(
                            name="name"
                            label="Name"
                            type="text"
                            v-bind:value="(this.$moonpull.getCurrentUserSession().name)"
                          )
                          MInput(
                            name="useremail"
                            label="Email"
                            type="text"
                            v-bind:value="(this.$moonpull.getCurrentUserSession().email)"
                          )
                          MInput(
                            name="company"
                            label="Company"
                            type="text"
                            v-bind:value="(this.$moonpull.getCurrentUserSession().company.name)"
                          )
                          MInput(
                            name="advertiser"
                            label="Advertiser"
                            type="text"
                            v-bind:value="getAlpDomain(auditData)" 
                          )
                          MInput(
                            name="auditurl"
                            label="Audit URL:"
                            type="text"
                            v-bind:value="`https://app.mnpll.com/#/reporting/audits/${$route.params.auditId}/output-report`"
                          )
                          div( class="row" )
                            div( class="col-md-9 contact-words" )
                              strong( class="text-left" ) Is this enquiry about Moonpull not clicking on 'Accept All'?&nbsp;
                            div( class="col-md-3 contact-checkbox" )
                              MInput(
                                type="checkbox"
                                name="acceptAll"
                                value="false"
                              )
                          MInput(
                            name="text"
                            label="Message:"
                            type="textarea"
                            required
                          )

                    div( class="btn-group" v-if="!isUnsupportedNetwork" )
                      button( class="btn btn-details btn-outline btn-info ml-2" v-on:click="downloadConsentAndRefreshReport" v-if="showButton('consentAndRefresh')"   )
                        | Download Report
                      button( class="btn btn-details btn-outline btn-info ml-2" v-on:click="downloadNoAniReport" v-else-if="showButton('noAni')" )
                        | Download Report
                      button( class="btn btn-details btn-outline btn-info ml-2" v-on:click="downloadNoCookieReport" v-else-if="showButton('noCookie')"  )
                        | Download Report
                      button( class="btn btn-details btn-outline btn-info ml-2" v-on:click="downloadConsentOnlyReport" v-else-if="showButton('consentOnly') "  )
                        | Download Report
                      button( class="btn btn-details btn-outline btn-info ml-2" v-on:click="downloadImmediateReport" v-else-if="showButton('immediate') && $moonpull.getCurrentUserSession().company.companyType === 'AGENCY' || $moonpull.currentUserIsSuperAdmin()"  )
                        | Download Report
                      //- button( class="btn btn-details btn-outline btn-info ml-2" v-on:click="toggleAuditReports" v-else-if="shouldShowButton()"  )
                      //-   i( class="fa fa-caret-down " )
                      //-   | Audit Reports
                      ul( class="dropdown-menu" v-bind:class="showDropdown1 && 'show' " x-placement="bottom-start" )
                        li
                          MModalButton(
                            v-bind:button-text="'Overview Report'"
                            title="Audit Overview Report"
                            modal-size="modal-lg"
                            button-classes="dropdown-item"
                          )
                            div( slot="body" )
                              div( v-if="downloadingAuditOverviewReport" )
                                p Downloading...
                                p( class="text-right" )
                                  button( class="btn btn-secondary" v-on:click="closeSendMailModal" ) Close
                              MForm( v-else v-on:submit="handleFormSubmit" submit-text="Download" )
                                div( :class="{'alert alert-warning text-left': isAuditDataOld}")
                                  h3( v-if="isAuditDataOld") This audit is older than 7 days, please consider rerunning the audit for more accurate data.
                                  h3(v-else)  If older than 7 days, please consider rerunning the audit for more accurate data.
                                p( class="text-left" ) We recommend that you add some conversion and/or financial impact information to illustrate the potential significance of a possible tracking matter to you.  It might also be beneficial to explain  how this concern/issue might impact on your future promotions.
                                p( class="text-left" ) This will help an advertiser understand the significance and timeliness of an issue and hopefully get you a quick resolution to any issue.
                                div( class="text-right" )
                                  span Comment:
                                    textarea(
                                      slot="body"
                                      class="form-control"
                                      placeholder="Add a comment to this link"
                                      rows="10"
                                      v-model="auditData.clientComment"
                                    )
                                    button( class="btn btn-success mb-4 mt-4" v-on:click="addComment" ) Save comment & Download
                        
                        li( v-if="$moonpull.currentUserIsSuperAdmin()" )
                          div( class="btn-group")
                            MModalButton(
                              title="Advertiser Tracking Status Report"
                              modal-size="modal-lg"
                              button-classes="dropdown-item"
                            )
                              span( slot="button-inner" )
                                MMoonpullIcon
                                | &nbsp;Advertiser Tracking Status Report
                              div( slot="body" )
                                div( v-if="downloadingAuditOverviewReport" )
                                  p Downloading...
                                  p( class="text-right" )
                                    button( class="btn btn-secondary" v-on:click="closeSendMailModal" ) Close
                                MForm( v-else v-on:submit="downloadTrackingStatusReport" submit-text="Download" )
                                    p( class="text-left" ) Please add a comment for inclusion on the report.  It might be about forthcoming tracking environment changes about which to be aware or possible improvements in the existing implementation.
                                    p( class="text-left" ) The aim of this report is to confirm the continuing operation of a tracking implementation and prepare the advertiser for any necessary improvements needed in order to have good tracking underpinning the publisher-advertiser relationship.
                                    div( class="text-right" )
                                      span Comment:
                                        textarea(
                                          slot="body"
                                          class="form-control"
                                          placeholder="Add a comment to this link"
                                          rows="10"
                                          v-model="auditData.clientComment"
                                        )
                                        button( class="btn btn-success mb-4 mt-4" ) Save comment & Download
                                MLoadingSpinner( class="mr-2" v-if="downloadingTrackingStatusReport" )
                                i( class="fa fa-download mr-2" v-else )
                                | Advertiser Tracking Status Report

          hr( v-if="! shouldShowPlatformResult" )
          div( v-else )
            div( class="tabs-container" )
              ul( class="nav nav-tabs" role="tablist" )
                li
                  a( href="#" class="nav-link" v-bind:class="{ 'active': currentTab === 'alp' }" v-on:click.prevent="switchTab('alp')" )
                    span Journey &amp; Initial Landing&nbsp;

                li( v-if="hasAlpPostConsent()" )
                  a( href="#" class="nav-link" v-bind:class="{ 'active': currentTab === 'alp-post-consent' }" v-on:click.prevent="switchTab('alp-post-consent')" )
                    span After "Accept All" Engagement&nbsp;

                li( v-if="hasAlpPostConsentRefresh()" )
                  a( href="#" class="nav-link" v-bind:class="{ 'active': currentTab === 'alp-post-consent-refresh' }" v-on:click.prevent="switchTab('alp-post-consent-refresh')" )
                    span After a further page refresh&nbsp;

              div( v-bind:class="{ 'tab-content': ! pdfBtn }" v-for="stage in [ 'alp', 'alp-post-consent', 'alp-post-consent-refresh' ]" )
                div( class="tab-pane" v-bind:class="{ 'active': currentTab === stage }" role="tabpanel" )
                  div( class="panel-body" )
                    div( class="row" )
                      div( class="col-md-6 col-lg-8" )
                        
                        div( v-if="auditData.status === 'FAILED'" )
                          h3 Moonpull could not audit this link

                        div( v-if="auditData.status !== 'FAILED' || $moonpull.currentUserIsSuperAdmin()" )

                          div( v-if="auditData.status === 'FAILED'" )
                            h4( class="border-bottom border-top py-2 mt-4" )
                              MMoonpullIcon( class="mr-2" )
                              | Additional available details

                          p( v-if="currentTab === 'alp'" )
                            em( v-if="hasAlpPostConsent()" ) This represents the situation if the user declines further cookies within any consent process.
                            em( v-else ) No process to allow the user to give and manage consent for cookies was found.

                          h2( class="mt-0" ) Identified issues
                          div( class="my-2")
                            label
                              input( type="checkbox" v-model="showPublisherErrors")
                              em( class="ml-2") Show issues identified that are associated with the publisher link and its parameters

                          span( v-if="getErrorsInOrder(stage).length === 0" ) No noteable issues were found
                          template( v-else )
                            div( class="error-row-container" v-for="error in getErrorsInOrder(stage)" )
                              div( class="row d-flex align-items-center" v-if="! error.moonpullOnly || $moonpull.currentUserIsSuperAdmin()" )

                                div( class="col-lg-3" )
                                  span( class="badge" v-bind:class="{ 'badge-danger': error.critical, 'badge-warning': error.warning, 'badge-secondary': error.notice }" )
                                    MMoonpullIcon( v-if="error.moonpullOnly" class="mr-2" )
                                    span( v-if="canViewFlashes()" ) 
                                      span {{ error.moonpullErrorId }}
                                    span( v-else )
                                      span( v-if="error.critical" ) Critical
                                      span( v-else-if="error.warning" ) Warning
                                      span( v-else-if="error.notice" ) Notice

                                div( class="col-lg-6" )
                                  strong {{ error.title }}

                                div( class="col-lg-3" )
                                  button( class="btn btn-outline btn-info" v-on:click="toggleMoreDetailsForError(error.moonpullErrorId)" )
                                    span( v-if="showMoreDetailsForError(error.moonpullErrorId)" )
                                      | Hide Summary&nbsp;
                                      i( class="fa fa-chevron-down" )

                                    span( v-else )
                                      | Show Summary&nbsp;
                                      i( class="fa fa-chevron-right" )
                              div( class="row mt-4" v-if="showMoreDetailsForError(error.moonpullErrorId)" )
                                div( class="col-lg-12" )
                                  h3 Summary
                                  p {{ error.problem }}
                      div( class="col-md-6 col-lg-4" v-if="auditData.screenshots && auditData.screenshots.length > 0" )
                        div( class="screen-cap-container d-flex justify-content-between" )
                          strong( v-if="stage === 'alp'" ) Initial Landing 
                          strong( v-else-if="stage === 'alp-post-consent'" ) After "Accept All" Engagement
                          strong( v-else="stage === 'alp-post-consent-refresh'" ) After a further page refresh

                        div( class="screen-cap-container" )
                          div( class="screen-cap-container-inner" )
                            img( v-bind:src="getCurrentScreenshot(stage)" v-on:click="toggleFullscreenScreenshot(stage)" )
                          p( class="text-center mt-2 mb-0" ) {{ getCurrentScreenshotTimestamp(stage) }}
                          p( v-if="$moonpull.currentUserIsSuperAdmin()" class="text-center font-italic" )
                            MMoonpullIcon( class="mr-2" )
                            | Size: {{ (getCurrentScreenshotByteSize(stage) / 1024).toFixed(2) }}kb

            div( class="row mt-4" )
              div( class="col-lg-6" )
                div( class="ibox" )
                  div( class="ibox-content" )

                    h2 Comments

                    div( v-if="auditData.clientComment" )
                      strong Client Comment:
                      br
                      span {{ auditData.clientComment || 'No comment' }}

                    div( class="text-right" )
                      MModalButton(
                        v-bind:button-text="auditData.clientComment ? 'Edit Comment' : 'Add Comment'"
                        title="Add/Edit Comment"
                        button-classes="btn btn-link"
                        modal-size="modal-lg"
                      )
                        textarea(
                          slot="body"
                          class="form-control"
                          placeholder="Add a comment to this link"
                          rows="10"
                          v-model="auditData.clientComment"
                        )
                        div( slot="footer" class="text-right" )
                          button( class="btn btn-success" v-on:click="addComment" ) Save comment

                    template( v-if="$moonpull.currentUserIsSuperAdmin() && auditData.moonpullComment" )
                      hr
                      div( class="d-flex align-items-center" )
                        img( class="steve" src="../vendor/images/steve.jpg" alt="Steve" )
                        div
                          h3( class="ml-2 mb-0" ) Moonpull consultant commentary
                          p( class="p-2" ) {{ auditData.moonpullComment }}

                    div( class="text-right" )
                      MModalButton(
                        v-if="$moonpull.currentUserIsSuperAdmin()"
                        title="Add/Edit Moonpull Consultant's Comment"
                        button-classes="btn btn-link"
                        modal-size="modal-lg"
                      )
                        span( slot="button-inner" )
                          MMoonpullIcon
                          | &nbsp;{{ auditData.moonpullComment ? 'Edit Moonpull Comment' : 'Add Moonpull Comment' }}

                        textarea(
                          slot="body"
                          class="form-control"
                          placeholder="Add an official Moonpull comment to this link"
                          rows="10"
                          v-model="auditData.moonpullComment"
                        )

                        div( slot="footer" class="text-right" )
                          button( class="btn btn-success" v-on:click="addMoonpullComment" ) Save comment

              div( class="col-lg-6" )
                div( class="ibox" )
                  div( class="ibox-content" )

                    h2 Comment from {{ auditData.network }} / Advertiser: 

                    p( style="white-space:pre-line;" ) {{ (auditData.advertiser && auditData.advertiser.publicComment) || 'No advertiser insights for this link' }}

                    template( v-if="$moonpull.currentUserIsSuperAdmin()" )
                      hr
                      h2
                        MMoonpullIcon
                        | &nbsp;Moonpull Private Advertiser Comment

                      p( style="white-space:pre-line;" ) {{ (auditData.advertiser && auditData.advertiser.internalComment) || 'No internal comment for this advertiser' }}

            div( class="row" )
              div( class="col-lg-6" )
                div( class="ibox" )
                  div( class="ibox-content" )

                    div( class="row mb-3" )
                      div( class="col-4" )
                        h2 Data included with submitted links 

                      div( class="col-8 text-right" )
                        MModalButton(
                          v-if="$moonpull.currentUserIsSuperAdmin()"
                          button-classes="btn btn-default btn-xs"
                          modal-size="modal-lg"
                          title="View other audits of this advertiser"
                        )
                          span( slot="button-inner" )
                            MMoonpullIcon( class="mr-2" )
                            | View other audit results for this advertiser
                          
                          div( slot="body" class="text-left" v-if="! auditData.finalDomain" )
                            | Not available as this audit did not establish an ALP domain
                          
                          div( slot="body" class="text-left" v-else )
                            apollo-query(
                              v-bind:query="queryAuditsFilterByFinalDomain"
                              v-bind:variables="{ finalDomain: auditData.finalDomain }"
                            )
                              template( v-slot="{ result: { loading, error, data } }" )
                                div( v-if="loading" ) Loading...
                                div( v-else-if="data" )
                                  p View other audits for "{{ auditData.finalDomain }}":
                                  hr
                                  template( v-for="audit in data.auditMany.items.filter(audit => audit.id !== auditData.id)" )
                                    div( class="row" )
                                      div( class="col-12" )

                                        p
                                          strong Audit Page:&nbsp;
                                          router-link( target="_blank" v-bind:to="`/reporting/audits/${audit.id}/output-report`" )
                                            i( class="fa fa-external-link mx-2" )
                                            | View audit

                                        p
                                          strong Date Audited:&nbsp;
                                          | {{ dateFormat(audit.auditedAt, 'dS mmm yyyy, HH:MM') }}

                                        p
                                          strong Audit ID:&nbsp;
                                          | {{ audit.id }}

                                        p
                                          strong Batch Name:&nbsp;
                                          | {{ (audit.batch && audit.batch.name) || 'None' }}

                                        p
                                          strong Batch Description:&nbsp;
                                          | {{ (audit.batch && audit.batch.description) || 'None' }}

                                        p
                                          strong Run by:&nbsp;
                                          | {{ (audit.batch.owner && (audit.batch.owner.name || audit.batch.owner.email)) || 'Unknown' }}
                                          em( v-if="audit.batch.owner && audit.batch.owner.company && audit.batch.owner.company.name" ) &nbsp;@ {{ audit.batch.owner.company.name }}

                                        p
                                          strong Link audited:&nbsp;
                                          | {{ audit.link }}

                                        p( v-if="$moonpull.currentUserIsSuperAdmin()" )
                                          strong Moonpull Comment:&nbsp;
                                          | {{ audit.moonpullComment || 'No comment' }}
                                          br
                                          a( href="#" v-on:click.prevent="copyMetadata(audit, { moonpullComment: audit.moonpullComment })" )
                                            MLoadingSpinner( v-if="copyingMetadataLoading" class="mr-2" )
                                            | Copy Moonpull Comment to current audit

                                        p( v-if="$moonpull.currentUserIsSuperAdmin()" )
                                          strong Reasons:
                                          ul
                                            li( v-for="cause in audit.causes" ) {{ cause.reason }}

                                          a( href="#" v-on:click.prevent="copyMetadata(audit, { causes: audit.causes.map(c => c.id) })" )
                                            MLoadingSpinner( v-if="copyingMetadataLoading" class="mr-2" )
                                            | Copy reasons to current audit

                                        p 
                                          MTrackingMatrixOrStatus(:audit="audit")
                  div( class="ibox-content" )  
                    div( class="row mb-3" )
                      div( class="col-12 text-right" )
                        MModalButton(
                          v-if="$moonpull.currentUserIsSuperAdmin()"
                          button-classes="btn btn-default btn-xs"
                          modal-size="modal-lg"
                          title="View other audits of this Affiliate link"
                        )
                          span( slot="button-inner" )
                            MMoonpullIcon( class="mr-2" )
                            | View other audit results for submitted affiliate link
                          
                          div( slot="body" class="text-left" )
                            apollo-query(
                              v-bind:query="queryAuditsFilterByLink"
                              v-bind:variables="{ link: auditData.link }"
                            )
                              template( v-slot="{ result: { loading, error, data } }" )
                                div( v-if="loading" ) Loading...
                                div( v-else-if="data" )
                                  p View other audits for "{{ auditData.link }}":
                                  hr
                                  template( v-for="audit in data.auditMany.items.filter(audit => audit.id !== auditData.id)" )
                                    div( class="row" )
                                      div( class="col-12" )

                                        p
                                          strong Audit Page:&nbsp;
                                          router-link( target="_blank" v-bind:to="`/reporting/audits/${audit.id}/output-report`" )
                                            i( class="fa fa-external-link mx-2" )
                                            | View audit
                                        p
                                          strong Date Audited:&nbsp;
                                          | {{ dateFormat(audit.auditedAt, 'dS mmm yyyy, HH:MM') }}

                                        p
                                          strong Batch Name:&nbsp;
                                          | {{ (audit.batch && audit.batch.name) || 'None' }}

                                        p
                                          strong Batch Description:&nbsp;
                                          | {{ (audit.batch && audit.batch.description) || 'None' }}

                                        p
                                          strong Run by:&nbsp;
                                          | {{ (audit.batch.owner && (audit.batch.owner.name || audit.batch.owner.email)) || 'Unknown' }}
                                          em( v-if="audit.batch.owner && audit.batch.owner.company && audit.batch.owner.company.name" ) &nbsp;@ {{ audit.batch.owner.company.name }}
                                        p
                                          strong Link audited:&nbsp;
                                          | {{ audit.link }}

                                        p( v-if="$moonpull.currentUserIsSuperAdmin()" )
                                          strong Moonpull Comment:&nbsp;
                                          | {{ audit.moonpullComment || 'No comment' }}
                                          br
                                          a( href="#" v-on:click.prevent="copyMetadata(audit, { moonpullComment: audit.moonpullComment })" )
                                            MLoadingSpinner( v-if="copyingMetadataLoading" class="mr-2" )
                                            | Copy Moonpull Comment to current audit

                                        p( v-if="$moonpull.currentUserIsSuperAdmin()" )
                                          strong Reasons:
                                          ul
                                            li( v-for="cause in audit.causes" ) {{ cause.reason }}

                                          a( href="#" v-on:click.prevent="copyMetadata(audit, { causes: audit.causes.map(c => c.id) })" )
                                            MLoadingSpinner( v-if="copyingMetadataLoading" class="mr-2" )
                                            | Copy reasons to current audit
                                            
                                        p 
                                          MTrackingMatrixOrStatus(:audit="audit")
                                          
                                        p( v-if="$moonpull.currentUserIsSuperAdmin()" )
                                          strong Fail reason:&nbsp;
                                          | {{ audit.failReason }}
                                        

                                    hr

                    div( class="d-flex justify-content-between mb-4" v-if="$moonpull.currentUserIsSuperAdmin()" )
                      router-link( v-bind:to="`/reporting/audits/${$route.params.auditId}/cmp-insights`" )
                        MMoonpullIcon
                        | &nbsp;View CMP Insights


                    div( class="row mt-4" )
                      div( class="col-md-6" )
                        strong Batch Name:

                      div( class="col-md-6" )
                        span {{ auditData.batch.name || 'None' }}

                    div( class="row mb-4" )
                      div( class="col-md-6" )
                        strong Batch Description:

                      div( class="col-md-6" )
                        span {{ auditData.batch.description || 'None' }} 

                    div( class="row" )
                      div( class="col-md-6" )
                        strong Tag A:

                      div( class="col-md-6" )
                        span {{ auditData.tags[0] || 'None' }}

                    div( class="row" )
                      div( class="col-md-6" )
                        strong Tag B:

                      div( class="col-md-6" )
                        span {{ auditData.tags[1] || 'None' }}

                    div( class="row" )
                      div( class="col-md-6" )
                        strong Tag C:

                      div( class="col-md-6" )
                        span {{ auditData.tags[2] || 'None' }}

                    div( class="row" )
                      div( class="col-md-6" )
                        strong Tag D:

                      div( class="col-md-6" )
                        span {{ auditData.tags[3] || 'None' }}

                    div( class="row" )
                      div( class="col-md-6" )
                        strong Tag E:

                      div( class="col-md-6" )
                        span {{ auditData.tags[4] || 'None' }}

                    div( class="row mt-4" )
                      div( class="col-md-6" )
                        strong Submitted by:

                      div( class="col-md-6" )
                        span {{ (auditData.batch && auditData.batch.owner && (auditData.batch.owner.name || auditData.batch.owner.email)) || 'N/A' }}

                    div( v-if="$moonpull.currentUserIsSuperAdmin()" class="row mt-4" )
                      div( class="col-12" )
                        apollo-mutation(
                          v-bind:mutation="updateAuditCausesMutation"
                          v-bind:variables="getUpdateAuditCausesMutationVariables()"
                          v-on:done="updateAuditCausesMutationSuccess"
                          v-on:error="alert('Error saving causes. Please try again.')"
                        )
                          template( v-slot="{ mutate, loading, error }" )
                            strong Reason 1:&nbsp;
                            select( class="form-control" v-model="auditData.causes[0].id" v-bind:disabled="loading" )
                              option( selected v-bind:value="undefined" ) None
                              option( v-for="cause in causes" v-bind:value="cause.id" ) {{ cause.reason }}

                            strong Reason 2:&nbsp;
                            select( class="form-control" v-model="auditData.causes[1].id" v-bind:disabled="loading" )
                              option( selected v-bind:value="undefined" ) None
                              option( v-for="cause in causes" v-bind:value="cause.id" ) {{ cause.reason }}

                            strong Reason 3:&nbsp;
                            select( class="form-control" v-model="auditData.causes[2].id" v-bind:disabled="loading" )
                              option( selected v-bind:value="undefined" ) None
                              option( v-for="cause in causes" v-bind:value="cause.id" ) {{ cause.reason }}

                            p( class="text-right mt-2" )
                              span( v-if="causesSavedSuccessfully" class="text-success" ) Saved!&nbsp;
                              button( class="btn btn-primary" v-on:click="mutate" v-bind:disabled="loading" )
                                MMoonpullIcon
                                | &nbsp;Save Reasons

              div( class="col-lg-6" )
                div( class="ibox" )
                  div( class="ibox-content" )

                    div( class="row" )
                      div( class="col-lg-8" )
                        h2 Submitted Link Details

                      div( class="col-lg-4 text-right" )
                        button( class="btn btn-outline btn-success" v-on:click="submittedLinkMoreDetails = ! submittedLinkMoreDetails" )
                          span( v-if="submittedLinkMoreDetails" )
                            | Less details
                            i( class="fa fa-chevron-down ml-2" )
                          span( v-else )
                            | More details
                            i( class="fa fa-chevron-right ml-2" )

                    div( class="row" )
                      div( class="col-md-6" )
                        strong Network:

                      div( class="col-md-6" )
                        span {{ auditData.network }}

                    div( class="row" )
                      div( class="col-md-6" )
                        strong Publisher ID:

                      div( class="col-md-6" )
                        span {{ auditData.inferredNetworkVariables && auditData.inferredNetworkVariables.publisherId || 'None found' }}

                    div( class="row" )
                      div( class="col-md-6" )
                        strong Advertiser ID / ID to commence:

                      div( class="col-md-6" )
                        span {{ auditData.inferredNetworkVariables && auditData.inferredNetworkVariables.advertiserId || 'None found' }}

                    template( v-if="submittedLinkMoreDetails" )
                      div( class="row mt-4" )
                        div( class="col-md-6" )
                          strong Click Reference:

                        div( class="col-md-6" )
                          span {{ auditData.inferredNetworkVariables && auditData.inferredNetworkVariables.clickRef || 'None found' }}

                      div( class="row" )
                        div( class="col-md-6" )
                          strong Deeplink:

                        div( class="col-md-6" )
                          span {{ auditData.inferredNetworkVariables && auditData.inferredNetworkVariables.deepLinkId || 'None found' }}

                      div( class="row mt-4" v-if="$moonpull.currentUserIsSuperAdmin()" )
                        div( class="col-md-6" )
                          strong Extracted Network Definitive Prog ID:

                        div( class="col-md-6" )
                          span {{ auditData.inferredNetworkVariables && auditData.inferredNetworkVariables.networkDefinitiveProgId || 'N/A' }}

                      div( class="row" )
                        div( class="col-md-6" )
                          strong Extracted Advertiser:

                        div( class="col-md-6" )
                          span {{ getAlpDomain(auditData) || 'None found' }}

                div( class="ibox" )
                  div( class="ibox-content" )  

                    div( class="row" )
                      div( class="col-lg-8" )
                        h2 Network Provided Information

                      div( class="col-lg-4 text-right" )
                        button( class="btn btn-outline btn-success" v-on:click="networkInfoMoreDetails = ! networkInfoMoreDetails" )
                          span( v-if="networkInfoMoreDetails" )
                            | Less details
                            i( class="fa fa-chevron-down ml-2" )
                          span( v-else )
                            | More details
                            i( class="fa fa-chevron-right ml-2" )

                    div( class="row" )
                      div( class="col-12" )
                        em( v-if="auditData.advertiserEstablishMethod === 'DEFINITIVE_PROG'" ).
                          Advertiser was found on Moonpull's advertiser table by matching a
                          parameter in the submitted URL (the definitive program ID)
                        
                        em( v-else-if="auditData.advertiserEstablishMethod === 'ADVERTISER_ID'" ).
                          Advertiser was found on Moonpull's advertiser table by matching a
                          parameter in the submitted URL (the advertiser's ID)
                        
                        em( v-else-if="auditData.advertiserEstablishMethod === 'DOMAIN'" ).
                          Advertiser was found on Moonpull's advertiser table by using the ALP domain
                        
                        em( v-else-if="auditData.advertiserEstablishMethod === 'USER_DEFINED_MERCHANT'" ).
                          Advertiser was found on Moonpull's advertiser table by specifically hinting
                          the advertiser name in the CSV upload
                        
                        em( v-else-if="auditData.advertiserEstablishMethod === 'AUTOMATIC'" ).
                          Advertiser was automatically created from this audit because an appropriate
                          advertiser ID was found based on the network's config
                        
                        em( v-else-if="!! auditData.advertiser" ).
                          Advertiser was found on Moonpull's advertiser table via an unspecified method
                        
                        em( v-else ) Advertiser was not found on Moonpull's advertiser table

                      div( class="col-12 mt-2" )
                        strong( v-if="auditData.isAdvertiserDiff" )
                          em Advertiser details have changed since this audit ran. Current values are in #[span( class="text-danger" ) red].
                        strong( v-else-if="!! auditData.advertiser" )
                          em This is the information at the time of the audit.

                    div( class="row mt-4" )
                      div( class="col-md-6" )
                        strong Custom Cookie Type:

                      div( class="col-md-6" )
                        span {{ (auditData.advertiserSnapshot && auditData.advertiserSnapshot.bespokeCookieValueType) || 'N/A' }}
                        span( v-if="auditData.isAdvertiserDiff" class="text-danger" )
                          | &nbsp;
                          | ({{ (auditData.advertiser && auditData.advertiser.bespokeCookieValueType) || 'N/A' }})

                    div( class="row" )
                      div( class="col-md-6" )
                        strong Custom Cookie Name:

                      div( class="col-md-6" )
                        span {{ (auditData.advertiserSnapshot && auditData.advertiserSnapshot.bespokeCookieName) || 'N/A' }}
                        span( v-if="auditData.isAdvertiserDiff" class="text-danger" )
                          | &nbsp;
                          | ({{ (auditData.advertiser && auditData.advertiser.bespokeCookieName) || 'N/A' }})

                    div( class="row" )
                      div( class="col-md-6" )
                        strong Custom ANI:

                      div( class="col-md-6" )
                        span {{ (auditData.advertiserSnapshot && auditData.advertiserSnapshot.bespokeAni) || 'N/A' }}
                        span( v-if="auditData.isAdvertiserDiff" class="text-danger" )
                          | &nbsp;
                          | ({{ (auditData.advertiser && auditData.advertiser.bespokeAni) || 'N/A' }})

                    div( class="row" v-if="$moonpull.currentUserIsSuperAdmin()" )
                      div( class="col-md-6" )
                        MMoonpullIcon
                        strong &nbsp;Master Tag:

                      div( class="col-md-6" )
                        span {{ (auditData.advertiserSnapshot && auditData.advertiserSnapshot.bespokeMasterTag) || 'N/A' }}
                        span( v-if="auditData.isAdvertiserDiff" class="text-danger" )
                          | &nbsp;
                          | ({{ (auditData.advertiser && auditData.advertiser.bespokeMasterTag) || 'N/A' }})

                    template( v-if="networkInfoMoreDetails" )
                      div( class="row mt-4" )
                        div( class="col-md-6" )
                          strong Network Definitive Prog ID:

                        div( class="col-md-6" )
                          span {{ (auditData.advertiserSnapshot && auditData.advertiserSnapshot.advertiserId) || 'None found' }}
                          span( v-if="auditData.isAdvertiserDiff" class="text-danger" )
                            | &nbsp;
                            | ({{ (auditData.advertiser && auditData.advertiser.advertiserId) || 'N/A' }})

                      div( class="row" )
                        div( class="col-md-6" )
                          strong Domain:

                        div( class="col-md-6" )
                          span {{ (auditData.advertiserSnapshot && auditData.advertiserSnapshot.domain) || 'None found' }}
                          span( v-if="auditData.isAdvertiserDiff" class="text-danger" )
                            | &nbsp;
                            | ({{ (auditData.advertiser && auditData.advertiser.domain) || 'N/A' }})



                      div( class="row" )
                        div( class="col-md-6" )
                          strong Advertiser Tracking Narrative:

                        div( class="col-md-6" )
                          span {{ (auditData.advertiserSnapshot && auditData.advertiserSnapshot.trackingMethodNarrative) || 'N/A' }}
                          span( v-if="auditData.isAdvertiserDiff" class="text-danger" )
                            | &nbsp;
                            | ({{ (auditData.advertiser && auditData.advertiser.trackingMethodNarrative) || 'N/A' }})

                      div( class="text-right" v-if="$moonpull.currentUserIsSuperAdmin() || $moonpull.currentUserIsNetworkUser() || $moonpull.currentUserIsGlobalNetworkUser()" )
                        router-link(
                          v-if="!! auditData.advertiser"
                          class="btn btn-primary"
                          v-bind:to="`/cms/advertisers/${auditData.advertiser.id}/update`"
                          target="_blank"
                        )
                          | Update Advertiser
                          i( class="fa fa-external-link ml-2" )

                        router-link(
                          v-else
                          class="btn btn-primary"
                          v-bind:to="`/cms/advertisers/create?advertiserId=${auditData.inferredNetworkVariables.advertiserId}&domain=${auditData.finalDomain}&network=${auditData.network}`"
                          target="_blank"
                        )
                          | Create Advertiser
                          i( class="fa fa-external-link ml-2" )

        div( class="fullscreen-screenshot" v-if="showFullscreenScreenshot" )
          i( class="fa fa-times" v-on:click="showFullscreenScreenshot = false" )
          div( class="tabs-container" )
              ul( class="nav nav-tabs" role="tablist" )
                li( v-if="!! auditData.screenshots.find(s => s.stage === 'interstitial')" )
                  a( href="#" class="nav-link" v-bind:class="{ 'active': currentFullScreenshotStage === 'interstitial' }" v-on:click.prevent="toggleFullscreenScreenshot('interstitial')" )
                    span Consent Interstitial

                li
                  a( href="#" class="nav-link" v-bind:class="{ 'active': currentFullScreenshotStage === 'alp' }" v-on:click.prevent="toggleFullscreenScreenshot('alp')" )
                    span Initial Landing

                li( v-if="hasAlpPostConsent()" )
                  a( href="#" class="nav-link" v-bind:class="{ 'active': currentFullScreenshotStage === 'alp-post-consent' }" v-on:click.prevent="toggleFullscreenScreenshot('alp-post-consent')" )
                    span After "Accept All" Engagement

                li( v-if="hasAlpPostConsentRefresh()" )
                  a( href="#" class="nav-link" v-bind:class="{ 'active': currentFullScreenshotStage === 'alp-post-consent-refresh' }" v-on:click.prevent="toggleFullscreenScreenshot('alp-post-consent-refresh')" )
                    span After a further page refresh

          div( class="text-center pt-4" )
            img( v-bind:src="fullscreenScreenshot" v-if="fullscreenScreenshot" )
        div( v-if="pdfBtn" )
          div( class="prev-next-links-nav navbar navbar-static-top border-top d-flex justify-content-end" )
            div( v-if="hasLinks" )
          div( class="row mt-2 custom-title" )
            div( class="col-md-8" )
              h2(
                v-bind:class="{ 'page-title': true, 'mt-4': !hasLinks, 'mt-3': hasLinks }"
              ) {{ auditData.name || (auditData.advertiser && auditData.advertiser.name) || getAlpDomain(auditData) || auditData.id.substr(-4) }}

              p( class="link-audited mb-0" )
                strong Link audited:&nbsp;
                a( target="_blank" v-bind:href="auditData.link" ) {{ auditData.link.substr(0, 100) }}{{ (auditData.link.length > 100) ? '...' : '' }}

              p( class="mb-0" )
                strong Audited at:&nbsp;
                | {{ dateFormat(auditData.auditedAt, 'dS mmmm yyyy') }}

              p
                router-link( v-bind:to="`/reporting/audits/${$route.params.auditId}/technical-report`" ) View Moonpull Technical Report

          div( class="wrapper wrapper-content" )
            div( )
              div( v-if="editingStatusAndAssignment" )
                span Status:
                MEntityChildUpdate(
                  entity="audit"
                  child="status"
                  child-sort="{ order: ASC }"
                  v-bind:child-fields="[ 'order', 'narrative' ]"
                  v-bind:object="auditData"
                  object-child-field="assessmentStatus"
                  v-slot="{ child: { order, narrative } }"
                ) {{ narrative }}
                span Link Owner:
                MEntityChildUpdate(
                  entity="audit"
                  child="user"
                  v-bind:child-fields="[ 'name', 'email' ]"
                  v-bind:object="auditData"
                  object-child-field="assignedTo"
                  v-slot="{ child: { name, email } }"
                ) {{ name }}
                span( class="inline-block" ) (last updated {{ dateFormat(auditData.updatedAt, 'dd/mm/yy, HH:MM') }})
                a( href="#" v-on:click.prevent="editingStatusAndAssignment = false" ) Save
              div( v-else )
                div( class="row")
                  div(class="col-md-8")
                    span( class="inline-block" )
                      | Link Owner:&nbsp;
                      strong {{ (auditData.assignedTo && `${auditData.assignedTo.name}`) || 'Not yet assigned' }}
                    a( href="#" v-on:click.prevent="editingStatusAndAssignment = true" )
          div( class="row custom-title" )
            div( class="col-md-12" )
              strong Audit Highlights:
          div( class="row custom-title" )
            div( class="col-md-6" )
              span() Country: {{ auditData.proxyDetails.country }}
              br
              span() CMP detected: {{ (auditData.detectedCmp && auditData.detectedCmp.name) || auditData.cmpVendor || 'No CMP found' }}
          hr
          div( class="row custom-title" )
            div( class="col-md-4" )
              strong Link Audit Synopsis
            div( class="col-md-12" )
              span() {{ auditData.clientComment }}
            div( class="col-md-12 mt-4" )
              strong Moonpull Audit URL: 
                strong() {{ `app.mnpll.com/#/reporting/audits/${$route.params.auditId}/output-report` }}
          hr
          div( class="row")
            strong( class="ml-4") Visible page on initial landing
          div( class="row" )
            div( class="col-md-12 col-lg-8")
              div( class="screen-cap-container" )
                div( class="screen-cap-container-inner" )
                  img( v-bind:src="getCurrentScreenshot('alp')" v-on:click="toggleFullscreenScreenshot(stage)" )
          hr
          div( class="row custom-title" )
            div( class="col-sm-12" )
              h2 Significant identified issues
            div( class="col-sm-12" )
              span Further issues may have been identified.  Visit Moonpull audit for more details.
          div( class="row custom-title" )
            div( class="col-sm-12" )
              span( v-if="getErrorsInOrder('alp').length === 0" ) No noteable issues were found
              template( v-else )
                div( class="error-row-container-pdf" v-for="error in getErrorsInOrder('alp')" )
                  div( class="row d-flex align-items-center" v-if="! error.moonpullOnly || $moonpull.currentUserIsSuperAdmin()" )
                    div( class="col-lg-12" )
                      strong {{ error.title }}
                div( class="error-row-container-pdf" v-for="error in getErrorsInOrder('alp-post-consent')" )
                  div( class="row d-flex align-items-center" v-if="! error.moonpullOnly || $moonpull.currentUserIsSuperAdmin()" )
                    div( class="col-lg-12" )
                      strong {{ error.title }}
                div( class="error-row-container-pdf" v-for="error in getErrorsInOrder('alp-post-consent-refresh')" )
                  div( class="row d-flex align-items-center" v-if="! error.moonpullOnly || $moonpull.currentUserIsSuperAdmin()" )
                    div( class="col-lg-12" )
                      strong {{ error.title }}
          hr  
          footer( class="" )
            div( class="row mt-4" )
              div( class="col-sm-8" )
                img(  src="/img/moonpull-logo-blue.png" alt="Moonpull" class="logo" )
              div( class="col-sm-4" )
                h2() moonpullpartners.com

</template>

<style lang="scss" scoped>
.steve {
  border-radius: 100%;
  width: 90px;
  border: 3px solid #cddce3;
}

.prev-next-links-nav {
  margin: 0 0 0 -15px;
  width: calc(100% + 30px);

  font-size: 0.9em;
  color: #3170f7;
}
ul.dropdown-menu {
  left: -130px;
}
.orange-highlight {
  background-color: orange;
  color: white;
  padding: 10px;
}

.nav-link,
.nav-link:not(.active):hover,
.nav-link:not(.active):active,
.nav-link:not(.active):focus {
  border-color: #dee2e6 #dee2e6 #fff;
}

.custom-title.floating .crawled-score {
  padding: 10px;
}

.handover-impact-badge.badge.badge-score {
  display: inline-block;
  height: 21px;
  margin-right: 10px;
  padding: 4px 12px;
  width: 40px;
  padding: 4px 0;
}

.key-observations {
  p {
    font-size: 0.9em;
    margin-bottom: 4px;
  }
}

.screen-cap-stage-btn-container {
  border-bottom: 1px solid #cddce3;

  button {
    text-align: left;
    font-weight: normal;

    &.selected {
      font-weight: bold;
    }
  }
}

.screen-cap-container {
  border: 1px solid #cddce3;
  padding: 10px;

  .screen-cap-container-inner {
    height: 300px;
    overflow-y: hidden;

    img {
      max-width: 100%;
      cursor: pointer;
    }
  }
}

.error-row-container {
  padding: 20px 0;
  border-top: 1px solid #cddce3;

  .badge {
    display: inline-block;
    font-size: 1.5em;
    padding: 5px 10px;
  }

  .description-centre-col {
    border-left: 1px solid #cddce3;
    border-right: 1px solid #cddce3;
  }
}
.error-row-container-pdf {
  padding: 10px 0;
  border-top: 1px solid #cddce3;

  .badge {
    display: inline-block;
    font-size: 1.5em;
    padding: 5px 25px;
  }

  .description-centre-col {
    border-left: 1px solid #cddce3;
    border-right: 1px solid #cddce3;
  }
}
.logo {
  height: 50px;
  max-width: 100%;
}

.comment-user-thumbnail-container {
  margin-right: 15px;

  .fa-user-circle {
    display: block;
    font-size: 2em;
  }
}

.add-comment-input {
  font-size: 1em;
}

.comment {
  margin-top: 10px;
  padding: 15px 0 0 0;
  border-top: 1px solid #cddce3;
}
.contact-words {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* Aligns text to the left */
}
.contact-checkbox {
  display: flex;
  align-items: center;
  justify-content: flex-end; /* Aligns checkbox to the right */
}

.fullscreen-screenshot {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: 100vh;
  padding: 15px;
  overflow-y: scroll;

  background: white;
  border-radius: 5px;
  border: 2px solid black;

  .fa.fa-times {
    position: absolute;
    top: 0px;
    right: 20px;
    font-size: 4em;
    cursor: pointer;
  }

  img {
    max-width: 100%;
    border: 1px solid #ddd;
  }
}
.value-calculator .inmodal .modal-header,
.value-calculator-success .inmodal .modal-header {
  text-align: left;
  border-bottom: 0;
  padding: 20px 30px 0px 30px;
}
.value-calculator .inmodal .modal-body,
.value-calculator-success .inmodal .modal-body {
  font-size: 14px;
  background: #fff;
  border-radius: 0 0 20px 20px;
  overflow-y: visible !important;
}
.value-calculator .inmodal .modal-footer,
.value-calculator-success .inmodal .modal-footer {
  display: none;
}
.value-calculator .inmodal .modal-body button {
  width: 150px;
}
.value-calculator .inmodal .modal-body span {
  color: #6f6f6f;
}
.value-calculator .inmodal .modal-body span.result {
  color: #234;
  font-size: 16px;
}
.value-calculator .inmodal .modal-body input {
  font-size: 16px;
  padding: 3px 6px;
  width: 100px;
  border: 1px solid #dddddd;
}
.value-calculator .modal-title {
  color: #b54708;
  padding: 5px 10px;
  display: inline-block;
  background: #fffaeb;
  border-radius: 5px;
  font-size: 16px !important;
}
.value-calculator-success .modal-title {
  color: #027a48;
  background: #f6fef9;
  padding: 5px 10px;
  display: inline-block;
  border-radius: 5px;
  font-size: 16px !important;
}
</style>

<script>
import Vue from "vue";
import * as dateFormat from "dateformat";
import gql from "graphql-tag";
import { createConsentAnalysisScenario } from "@/createConsentAnalysisScenario";
import { getMemoryCookieStatus } from "@/getMemoryCookieStatus";
import { getAdvertiserName } from "@/getAdvertiserName";
import { api } from "@/api";
import markdownit from "markdown-it";
import { isUnsupportedNetwork } from "@/unsupported-networks";

export default Vue.extend({
  data() {
    return {
      geminiCmpPrompt:
        "I will give you three screenshots of a web page, and I’d like you to perform a series of tasks. The first is the landing page (alp), the second is after consenting (alp-post-consent), and the final one is a refresh of the same page (alp-post-consent-refresh). Please refer to each image by its bracket name, alp, alp-post-consent, alp-post-consent-refresh. I'd like you to tell me if you see a consent platform, and tell me which consent platform you see. Tell me if it’s possible for the user to interact with the consent platform, paying attention to if the consent prompt is blocked by other elements such as age checks, country selection or marketing pop-overs. On the consent platform banner, which word must the user click to grant consent for cookies to be set. Identify in the alp-post-consent-refresh if the request to the website has been blocked, and try to identify why and how it’s been blocked.",
      geminiCmpResponse: null,
      geminiLoading: false,
      breadcrumbs: [
        { label: "Home", link: "/" },
        { label: "Reporting", link: "/reporting" },
        {
          label: `Output Report`,
          link: `/reporting/audits/${this.$route.params.auditId}/output-report`,
        },
      ],
      loading: true,
      loadingMultipleLinkSubmission: false,
      platformContent: null,
      screenshots: null,
      moonpullInvestigate: {
        auditId: this.$route.params.auditId,
        company: this.$moonpull.getCurrentUserSession().company.name,
        name: this.$moonpull.getCurrentUserSession().name,
        email: this.$moonpull.getCurrentUserSession().email,
        phone: "",
        requestDetails: "",
      },
      view: null,
      showImageModal: false,
      networkSpecificComments: {},
      causesSavedSuccessfully: false,
      moreDetailsForErrors: [],
      networks: undefined,
      comments: [
        {
          user: "Ollie",
          timestamp: "12 Jan '22",
          comment:
            "A long comment blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah",
        },
        {
          user: "Steve",
          timestamp: "10 Jan '22",
          comment: "This link looks good!",
        },
      ],
      currentTab: "alp",
      submittedLinkMoreDetails: false,
      networkInfoMoreDetails: false,
      showFullscreenScreenshot: false,
      fullscreenScreenshot: null,
      currentFullScreenshotStage: "alp",
      editingStatusAndAssignment: false,
      copyingMetadataLoading: false,
      showDropdown: false,
      showDropdown1: false,
      emailUser: null,
      name: null,
      showPublisherErrors: false,
      issue: "",
      pdfBtn: this.$route.query.pdfView === "1" || false,
      acceptAll: false,
      sendMailSuccessful: false,
      pdfPrinted: false,
      downloadingAuditOverviewReport: false,
      downloadingTrackingStatusReport: false,
      data: {
        currencySymbol: "",
        avgBasket: "",
        monthlyTrackedSales: "",
        aveCommission: null,
        proportionOfUsers: null,
        proportionConsent: null,
        monthlySalesValue: null,
        commissionPayable: null,
        improvedMonthlySalesValue: null,
        overalImprovement: null,
        improvedCommission: null,
        advertiserThirdParty: false,
        proportionOfUsers: 70,
        proportionConsent: 50,
        proportionConsentCalc2: "N/A",
        monthlySalesValue: null,
      },
      downloadingValueCalc: false,
      downloadingWarningCalc: false,
      showOldAuditModal: false,
      auditedAt: this.auditedAt,
      loadingLocalMemoryCookieCheck: false,
      showIssueReportDebugInfo: false,
      loadingLite: false,
      shouldExplicitlyShowPlatformResult: false,
      readableCsStatus: {
        reviewedCorrect: "Reviewed - Platform Result Correct",
        reviewedIncorrect: "Reviewed - Platform Result Incorrect",
      },
      delayOptions: [
        { value: 5 * 60, label: "5 minutes" },
        { value: 1800, label: "30 minutes" },
        { value: 3600, label: "1 hour" },
        { value: 10800, label: "3 hours" },
        { value: 21600, label: "6 hours" },
        { value: 43200, label: "12 hours" },
        { value: 86400, label: "24 hours" },
      ],
    };
  },

  apollo: {
    auditData: {
      query: gql`
        query($auditId: ID!) {
          auditById(id: $auditId) {
            id
            batch {
              id
              name
              description
              standDownMrAs
              owner {
                email
                name
                company {
                  name
                }
              }
            }
            order
            status
            assessmentStatus {
              id
              order
              narrative
            }
            assignedTo {
              id
              name
              email
            }
            link
            auditedAt
            name
            placement
            userDefinedNetwork
            userDefinedMerchant
            tags
            failReason
            auditTime
            auditedAt
            journey
            network
            advertiser {
              id
              name
              networkId
              advertiserId
              domain
              bespokeCookieValueType
              bespokeCookieName
              bespokeCookieValue
              bespokeAni
              bespokeMasterTag
              internalComment
              publicComment
              primaryTrackingMethod
              trackingMethodNarrative
              cannotAudit
              cannotAuditReason
              whitelistRequest {
                id
                whitelistActive
                whitelistSent
              }
              issueCount
              issueReportCount
            }
            advertiserSnapshot
            isAdvertiserDiff
            detectedCmpId
            detectedCmp {
              name
            }
            countryCode
            inferredNetworkVariables
            moonpullErrors
            cookiesWereAccepted
            cookieCounts
            internalErrorObj
            handoverImpact
            handoverImpactPostConsent
            handoverImpactPostConsentRefresh
            closedMerchant
            csvOverrideCookieType
            csvOverrideCookieName
            csvOverrideCookieValue
            csvOverrideAni
            csvOverrideMasterTag
            clientComment
            moonpullComment
            causes {
              id
              reason
            }
            advertiserEstablishMethod
            updatedAt
            finalDomain
            proxyDetails
            aniTruncated
            interstitialNavigated
            manualReviewRequired
            isRetry
            webUnlockerRequestId
            screenshots {
              stage
              byteSize
              screenshotUrl
              createdAt
            }
            useDataCentre
            batchLink {
              userDefinedNetwork
              link
              cookieName
              cookieType
              customAni
              customMasterTag
              countryCode
              postAlpURL
              skipConsent
            }
            isChangedFromComparison
            nextComparisonAudit {
              id
              auditedAt
              memoryCookieStatus
              isChangedFromComparison
            }
            previousComparisonAudit {
              id
              auditedAt
              memoryCookieStatus
              isChangedFromComparison
            }
            memoryCookieStatus
            memoryCookieStatusReadable
            enhancedMemoryCookieStatuses {
              id
              status
              statusReadable
              source
              sourceReadable
              sourceVerbiage
              comment
              createdAt
              updatedAt
            }
            injectedResult {
              id
              createdAt
              template {
                method
                createdAt
                methodComment
                status
                publisherType
                cookieName
                cookieValue
                cookieExpiry
                landingPageType
                readableStatus
                readablePublisherType
              }
            }
            siteAppAssociations
            liteResult
            cmpVendor
            reviewedStatus
            reviewedComment
            aiQuestionResults {
              id
              questionId
              aiResponse
              story
              actionTaken
              createdAt
            }
          }
        }
      `,

      variables() {
        return {
          auditId: this.$route.params.auditId,
        };
      },

      update(data) {
        const audit = data.auditById;
        if (!audit.causes[0]) audit.causes[0] = { id: null };
        if (!audit.causes[1]) audit.causes[1] = { id: null };
        if (!audit.causes[2]) audit.causes[2] = { id: null };

        if (!audit.moonpullErrors) {
          audit.moonpullErrors = [];
        }

        if (!audit.journey) {
          audit.journey = [];
        }

        if (!audit.finalDomain) {
          audit.finalDomain = "";
        }

        audit.moonpullErrors.sort(
          (a, b) => b.handoverImpactValue - a.handoverImpactValue
        );
        this.moreDetailsForErrors = audit.moonpullErrors.map((err) => ({
          id: err.moonpullErrorId,
          moreDetails: false,
        }));

        return audit;
      },
    },

    causes: {
      query: gql`
        query {
          causeMany {
            id
            reason
          }
        }
      `,
      update: (data) => data.causeMany,
    },
  },

  computed: {
    isReportable() {
      return (
        !!this.auditData.advertiser &&
        this.$moonpull.currentUserIsMoonpullShareUser()
      );
    },

    injectedResultFirstPartyTrackingStatus() {
      const injectedStatus = this.auditData.injectedResult?.template.status;
      if (injectedStatus) {
        return this.getReadableMemoryCookieStatus(injectedStatus);
      }
      return null;
    },

    hasLinks() {
      return this.auditData.prevLink || this.auditData.nextLink;
    },

    batchLink() {
      return {
        name: "reporting-memory-cookie",
        params: {
          batchId: this.auditData.batch.id,
          view: this.view,
        },
      };
    },

    cmpLink() {
      return {
        name: "report-detail-insights",
        params: {
          auditId: this.$route.params.auditId,
          view: this.view,
        },
      };
    },

    isAuditDataOld() {
      return this.isDataOlderThanSevenDays(this.auditData.auditedAt);
    },

    isAuditOlderThanSevenDays() {
      if (!this.auditData || !this.auditData.auditedAt) return false;
      const auditDate = new Date(this.auditData.auditedAt);
      const now = new Date();
      const ageInDays = (now - auditDate) / (1000 * 60 * 60 * 24);
      return ageInDays > 7;
    },

    commentPlaceHolder() {
      if (this.auditData.batch.owner.company.name === "Student Beans") {
        return `Please ask me (${
          this.$moonpull.getCurrentUserSession().name
        }, ${
          this.$moonpull.getCurrentUserSession().email
        }) for the reasons that I've sent this report to you and the concern that I'm raising with you.Additionally, in our business information, we've seen a conversion metric change of: [please complete] in the period from [date]  to [date]. User consent is now increasingly required for first party tracking.  Therefore knowing that we're rewarded for referrals that would generate a commission if it wasn't for the lack of consent is important.You may be receiving the report as the first step to having the conversation with us about this. Please see the accompanying Student Beans help sheet for more information.`;
      }
      return "Please enter your comment here";
    },

    shouldShowPlatformResult() {
      return (
        this.shouldExplicitlyShowPlatformResult ||
        (!this.auditData.injectedResult &&
          !this.auditData.enhancedMemoryCookieStatuses?.[0])
      );
    },

    isAuditedRecently() {
      if (!this.auditData.auditedAt) return false;
      const auditDate = new Date(this.auditData.auditedAt);
      const now = new Date();
      const diffInMs = now - auditDate;
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
      return diffInDays < 8;
    },

    reviewedStatus: {
      get() {
        return this.auditData.reviewedStatus;
      },
      set(value) {
        this.auditData.reviewedStatus = value;
      },
    },

    isUnsupportedNetwork() {
      return isUnsupportedNetwork(this.auditData.network);
    },
  },

  methods: {
    dateFormat,

    getMemoryCookieStatus,
    getAdvertiserName,

    async loadAiInteractions() {
      try {
        const response = await api(
          "GET",
          `/gemini/ai-interactions?auditId=${this.auditData.id}`
        );
        if (response.ok === false) {
          throw new Error(response.statusText);
        }

        const aiInteractions = await response.json();
        if (
          !aiInteractions.interactions ||
          aiInteractions.interactions.length === 0
        ) {
          return;
        }

        this.geminiCmpPrompt =
          aiInteractions.interactions[0].prompt || this.geminiCmpPrompt;
        const geminiReply = aiInteractions.interactions[0].response || null;
        if (geminiReply) {
          const md = markdownit();
          this.geminiCmpResponse = md.render(geminiReply.replace(/\\n/g, "\n"));
        }
      } catch (error) {
        this.$store.dispatch("flashMessage", {
          type: "danger",
          msg: `Cannot load historic Gemini interactions.\n\n${error.message}`,
        });
      }
    },

    async submitGeminiPrompt() {
      this.geminiLoading = true;
      this.geminiCmpResponse = null;

      if (!this.geminiCmpPrompt) {
        this.$store.dispatch("flashMessage", {
          type: "warning",
          msg: "Please enter a Gemini prompt before submitting.",
        });
        this.geminiLoading = false;
        return;
      }

      try {
        const response = await api("POST", "/gemini/analyse-audit-cmp-images", {
          auditId: this.auditData.id,
          prompt: this.geminiCmpPrompt,
        });

        const responseJson = await response.json();

        if (response.ok === false) {
          throw new Error(
            `${response.status} ${
              response.statusText
            } | ${responseJson.details || ""}`
          );
        }

        if (responseJson.text) {
          const md = markdownit();
          this.geminiCmpResponse = md.render(
            responseJson.text.replace(/\\n/g, "\n")
          );
        }
      } catch (error) {
        this.$store.dispatch("flashMessage", {
          type: "danger",
          msg: `${error.details || error.message}`,
        });
      } finally {
        this.geminiLoading = false;
      }
    },

    async updateReviewStatus() {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation UpdateReviewStatus($id: ID!, $record: AuditUpdateInput!) {
              auditUpdateById(id: $id, record: $record) {
                id
                reviewedStatus
                reviewedComment
              }
            }
          `,
          variables: {
            id: this.auditData.id,
            record: {
              reviewedStatus: this.auditData.reviewedStatus,
              reviewedComment: this.auditData.reviewedComment,
            },
          },
        });

        this.$store.dispatch("flashMessage", {
          type: "success",
          msg: "Review status updated successfully!",
        });
      } catch (error) {
        console.error("Error updating review status:", error);
        this.$store.dispatch("flashMessage", {
          type: "error",
          msg: "Failed to update review status.",
        });
      }
    },

    showPlatformResult() {
      this.shouldExplicitlyShowPlatformResult = true;
    },

    async updateReviewStatus() {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation UpdateReviewStatus($id: ID!, $record: AuditUpdateInput!) {
              auditUpdateById(id: $id, record: $record) {
                id
                reviewedStatus
              }
            }
          `,
          variables: {
            id: this.auditData.id,
            record: {
              reviewedStatus: this.auditData.reviewedStatus,
            },
          },
        });

        this.$store.dispatch("flashMessage", {
          type: "success",
          msg: "Review status updated successfully!",
        });

        // Optional: Refetch the audit if needed
        // this.$apollo.queries.auditData.refetch();
      } catch (error) {
        console.error("Error updating review status:", error);
        this.$store.dispatch("flashMessage", {
          type: "error",
          msg: "Failed to update review status.",
        });
      }
    },

    async onLiteSubmit() {
      if (
        confirm(
          `Running Lite manually will update and replace the existing Lite result. Are you sure?`
        )
      ) {
        this.loadingLite = true;
        try {
          await this.$apollo.mutate({
            mutation: gql`
              mutation WebUnlockerEMCS(
                $link: String!
                $auditId: ID!
                $countryCode: String!
                $blockMedia: Boolean!
              ) {
                webUnlockerEmcs(
                  link: $link
                  auditId: $auditId
                  countryCode: $countryCode
                  blockMedia: $blockMedia
                )
              }
            `,
            variables: {
              link: this.auditData.link,
              auditId: this.auditData.id,
              countryCode: this.auditData.countryCode || "gb",
              blockMedia: false,
            },
          });
          this.$store.dispatch("flashMessage", {
            type: "success",
            msg: "Lite is now auditing this link. Check back in ~2 mins.",
          });
        } catch (e) {
          console.error(e, e.stack);
          this.$store.dispatch("flashMessage", {
            type: "danger",
            msg: "An error occurred while trying to submit Lite Audit",
          });
        }
        this.loadingLite = false;
      }
    },

    getIssueReportDebugInfo() {
      const network = this.networks.find(
        (n) => n.name === this.auditData.network
      );
      return {
        "Advertiser match?": !!this.auditData.advertiser,
        "Advertiser name": this.auditData.advertiser?.name,
        "Moonpull Share enabled for company?":
          this.$moonpull.getCurrentUserSession()?.company
            .moonpullShareEnabled || false,
        "Moonpull Share enabled for user?": this.$moonpull.currentUserHasRole(
          "4dfdaf67-7726-45a8-a8a2-43ec92c6f863"
        ),
        "Network Type": network?.networkType || "None",
        "Network Owner": network?.owner?.name || "None",
      };
    },

    async localMemoryCookieCheck() {
      try {
        this.loadingLocalMemoryCookieCheck = true;

        // Get info required for local memory cookie check
        const {
          data: { localMemoryCookieCheckPayload },
        } = await this.$apollo.query({
          query: gql`
            query GetLocalMemoryCookieCheckPayload($auditId: ID!) {
              localMemoryCookieCheckPayload(auditId: $auditId) {
                auditId
                link
                tempApiKey
                memoryCookieKey
                memoryCookieValue
                aniKeys
                scriptSrcs
              }
            }
          `,
          variables: {
            auditId: this.auditData.id,
          },
        });

        // Trigger the extension
        document.dispatchEvent(
          new CustomEvent("chrome.runtime.sendMessage", {
            detail: {
              scope: "moonpull",
              action: "appraiseMemoryCookie",
              payload: localMemoryCookieCheckPayload,
            },
          })
        );
      } catch (e) {
        console.error(e, e.stack);
        this.$store.dispatch("flashMessage", {
          type: "danger",
          msg: e.message,
        });
      } finally {
        this.loadingLocalMemoryCookieCheck = false;
      }
    },

    shouldShowButton() {
      if (this.auditData.injectedResult) {
        return false;
      }
      if (this.auditData.memoryCookieStatus === "NOT_AUDITED") {
        return false;
      }
      if (this.auditData.enhancedMemoryCookieStatuses[0]) {
        return false;
      }
      return true;
    },

    shouldShowConsentChecker() {
      if (this.auditData.injectedResult) {
        return false;
      }
      if (this.auditData.enhancedMemoryCookieStatuses[0]) {
        return false;
      }
      if (
        this.auditData.memoryCookieStatus === "CONDITIONAL_ON_CMP_AND_REFRESH"
      ) {
        return true;
      }
      return false;
    },

    shouldShowupliftcalcImmediate() {
      if (
        this.auditData.enhancedMemoryCookieStatuses[0]?.status ===
          "IMMEDIATE" &&
        this.auditData.handoverImpact <
          this.platformContent.handoverImpactThresholdWarning
      ) {
        return true;
      }

      if (
        this.auditData.injectedResult?.template?.status === "IMMEDIATE" &&
        this.auditData.handoverImpact <
          this.platformContent.handoverImpactThresholdWarning
      ) {
        return true;
      }
      if (
        this.auditData.memoryCookieStatus === "IMMEDIATE" &&
        this.auditData.handoverImpact <
          this.platformContent.handoverImpactThresholdWarning
      ) {
        return true;
      }
    },

    shouldShowUpliftcalcNoCookie() {
      if (
        this.auditData.enhancedMemoryCookieStatuses[0]?.status ===
          "NO_MEMORY_COOKIE" &&
        this.auditData.handoverImpact >
          this.platformContent.handoverImpactThresholdWarning
      ) {
        return true;
      }
      if (
        this.auditData.injectedResult?.template?.status ===
          "NO_MEMORY_COOKIE" &&
        this.auditData.handoverImpact >
          this.platformContent.handoverImpactThresholdWarning
      ) {
        return true;
      }
      if (
        this.auditData.memoryCookieStatus === "NO_MEMORY_COOKIE" &&
        this.auditData.handoverImpact >
          this.platformContent.handoverImpactThresholdWarning
      ) {
        return true;
      }
    },

    shouldShowConsentModal() {
      if (
        this.auditData.injectedResult &&
        this.auditData.injectedResult.template.readableStatus === "CMP engaged"
      ) {
        return true;
      }
      if (
        this.auditData.enhancedMemoryCookieStatuses[0] &&
        this.auditData.enhancedMemoryCookieStatuses[0].status ===
          "CONDITIONAL_ON_CMP_AND_REFRESH"
      ) {
        return true;
      }
      return false;
    },

    async notifyOfIssues(auditData) {
      this.$apollo.query({
        query: gql`
          query(
            $emailUser: String
            $issue: String
            $affiliateLink: String
            $advertiserDomain: String
            $summary: String
            $auditId: ID!
            $user: ID!
            $userEmail: ID!
            $name: String
          ) {
            notifyOfIssues(
              emailUser: $emailUser
              issue: $issue
              affiliateLink: $affiliateLink
              advertiserDomain: $advertiserDomain
              summary: $summary
              auditId: $auditId
              user: $user
              userEmail: $userEmail
              name: $name
            )
          }
        `,
        variables: {
          emailUser: this.emailUser,
          issue: this.issue,
          affiliateLink: auditData.link,
          advertiser: this.advertiser,
          summary: this.summary,
          auditId: this.$route.params.auditId,
          name: this.name,
          user: this.$moonpull.getCurrentUserSession().name,
          userEmail: this.$moonpull.getCurrentUserSession().email,
        },
      });
      this.$emit("dismissModals");
      this.$store.dispatch("flashMessage", {
        type: "success",
        msg: "Assignment successful",
      });
    },

    isDataOlderThanSevenDays(auditDate) {
      const today = new Date();
      const auditedAtDate = new Date(auditDate);
      const ageInDays = (today - auditedAtDate) / (1000 * 60 * 60 * 24);
      return ageInDays > 8;
    },

    printPDF() {
      setTimeout(() => {
        window.print();
        this.pdfBtn = false;
      }, 4000);
    },
    valueCalculator(audit) {
      this.data.proportionConsent = Math.min(
        Math.max(this.data.proportionConsent, 1),
        99
      );
      this.data.proportionOfUsers = Math.min(
        Math.max(this.data.proportionOfUsers, 1),
        99
      );
      this.data.monthlySalesValue =
        this.avgBasket * this.data.monthlyTrackedSales;
      this.data.commissionPayable = Math.round(
        this.data.monthlySalesValue * (this.data.aveCommission / 100)
      );
      this.data.improvedMonthlySalesValue = Math.round(
        this.data.monthlySalesValue * (1 / (1 - this.data.percentTracked))
      );
      this.data.improvedCommission = Math.round(
        this.data.commissionPayable * (1 / (1 - this.data.percentTracked))
      );
      this.data.overalImprovement =
        Math.round(
          this.data.improvedMonthlySalesValue / this.data.monthlySalesValue
        ) - 1;
      if (audit.assessmentStatus?.narrative === "Tested ok - no CMP") {
        this.data.improvedMonthlySalesValue = Math.round(
          this.data.monthlySalesValue
        );
        this.data.improvedCommission = Math.round(this.data.commissionPayable);
      } else if (
        audit.assessmentStatus?.narrative === "Tested ok - CMP engaged" ||
        (audit.handoverImpactPostConsentRefresh >=
          this.platformContent.handoverImpactThresholdWarning &&
          audit.handoverImpactPostConsentRefresh <
            this.platformContent.handoverImpactThresholdCritical)
      ) {
        this.data.percentTracked =
          (1 - this.data.proportionOfUsers / 100) *
          (1 - this.data.proportionConsent / 100);
      } else if (
        audit.assessmentStatus?.narrative === "Issue to be categorised"
      ) {
        this.data.percentTracked = 1 - this.data.proportionOfUsers / 100;
      }
      this.data.monthlySalesValue =
        this.data.avgBasket * this.data.monthlyTrackedSales;
      this.data.commissionPayable = Math.round(
        this.data.monthlySalesValue * (this.data.aveCommission / 100)
      );
      this.data.improvedMonthlySalesValue = Math.round(
        this.data.monthlySalesValue * (1 / (1 - this.data.percentTracked))
      );
      this.data.improvedCommission = Math.round(
        this.data.commissionPayable * (1 / (1 - this.data.percentTracked))
      );
      this.data.overalImprovement = Math.round(
        100 *
          (this.data.improvedMonthlySalesValue / this.data.monthlySalesValue -
            1)
      );
      analytics.page(
        analytics.track("Value Calculator", {
          advertiser: this.finalDomain,
          network: this.network,
        })
      );
    },
    isWarningScenarioRefresh() {
      if (
        this.auditData.injectedResult?.template?.status ===
          "CONDITIONAL_ON_CMP_AND_REFRESH" ||
        (this.auditData.handoverImpactPostConsentRefresh >=
          this.platformContent.handoverImpactThresholdWarning &&
          !this.handoverImpactPostConsent >=
            this.platformContent.handoverImpactThresholdWarning)
      ) {
        return true;
      }

      if (
        this.auditData.enhancedMemoryCookieStatuses[0]?.status ===
          "CONDITIONAL_ON_CMP_AND_REFRESH" ||
        (this.auditData.handoverImpactPostConsentRefresh >=
          this.platformContent.handoverImpactThresholdWarning &&
          !this.handoverImpactPostConsent >=
            this.platformContent.handoverImpactThresholdWarning)
      ) {
        return true;
      }
      if (
        this.auditData.memoryCookieStatus ===
          "CONDITIONAL_ON_CMP_AND_REFRESH" ||
        (this.auditData.handoverImpactPostConsentRefresh >=
          this.platformContent.handoverImpactThresholdWarning &&
          !this.handoverImpactPostConsent >=
            this.platformContent.handoverImpactThresholdWarning)
      ) {
        return true;
      }
    },

    isWarningScenario() {
      if (
        this.auditData.enhancedMemoryCookieStatuses[0]?.status ===
          "CONDITIONAL_ON_CMP" ||
        (this.auditData.handoverImpactPostConsent >=
          this.platformContent.handoverImpactThresholdWarning &&
          !this.handoverImpactPostConsentRefresh >=
            this.platformContent.handoverImpactThresholdWarning)
      ) {
        return true;
      }
      if (
        this.auditData.injectedResult?.template?.status ===
          "CONDITIONAL_ON_CMP" ||
        (this.auditData.handoverImpactPostConsent >=
          this.platformContent.handoverImpactThresholdWarning &&
          !this.handoverImpactPostConsentRefresh >=
            this.platformContent.handoverImpactThresholdWarning)
      ) {
        return true;
      }
      if (
        this.auditData.memoryCookieStatus === "CONDITIONAL_ON_CMP" ||
        (this.auditData.handoverImpactPostConsent >=
          this.platformContent.handoverImpactThresholdWarning &&
          !this.handoverImpactPostConsentRefresh >=
            this.platformContent.handoverImpactThresholdWarning)
      ) {
        return true;
      }
    },

    resetCalculator() {
      this.currencySymbol = null;
      this.avgBasket = "";
      this.monthlyTrackedSales = "";
      this.aveCommission = null;
      this.monthlySalesValue = this.monthlyTrackedSales * this.avgBasket;
      this.commissionPayable = null;
      this.improvedMonthlySalesValue = null;
      this.overalImprovement = null;
      this.improvedCommission = null;
      this.advertiserThirdParty = false;
      this.proportionOfUsers = 70;
      this.proportionConsent = 50;
      this.monthlySalesValue = null;
    },

    isAuditOlderThanThreeMonths(auditDate) {
      const today = new Date();
      const dateOfAudit = new Date(auditDate);
      const threeMonthsAgo = new Date(today.setMonth(today.getMonth() - 3));
      return dateOfAudit < threeMonthsAgo;
    },

    async sendMail(data) {
      await this.$apollo.query({
        query: gql`
          query(
            $email: String!
            $message: String!
            $name: String!
            $company: String!
            $advertiser: String!
            $auditurl: String!
            $acceptAll: Boolean!
            $useremail: String!
          ) {
            mailCmpFromBatch(
              email: $email
              message: $message
              name: $name
              company: $company
              advertiser: $advertiser
              acceptAll: $acceptAll
              auditurl: $auditurl
              useremail: $useremail
            )
          }
        `,
        variables: {
          email: this.$moonpull.getCurrentUserSession().email,
          message: data.text,
          name: data.name,
          useremail: data.useremail,
          company: data.company,
          advertiser: data.advertiser,
          auditurl: data.auditurl,
          acceptAll: data.acceptAll,
        },
      });
      this.sendMailSuccessful = true;
    },
    async notifyCSAuditReport(data) {
      await this.$apollo.query({
        query: gql`
          query($email: String!, $name: String!, $reportUrl: String!) {
            notifyCSAuditReport(
              email: $email
              name: $name
              reportUrl: $reportUrl
            )
          }
        `,
        variables: {
          email: this.$moonpull.getCurrentUserSession().email,
          name: this.$moonpull.getCurrentUserSession().name,
          reportUrl: `https://app.mnpll.com/#/reporting/audits/${this.$route.params.auditId}/output-report`,
        },
      });
      this.sendMailSuccessful = true;
    },

    async generalQuery(data) {
      await this.$apollo.query({
        query: gql`
          query(
            $name: String!
            $email: String!
            $useremail: String!
            $company: String!
            $message: String!
          ) {
            generalQuery(
              email: $email
              message: $message
              name: $name
              company: $company
              useremail: $useremail
            )
          }
        `,
        variables: {
          email: this.$moonpull.getCurrentUserSession().email,
          message: data.text,
          name: data.name,
          useremail: data.useremail,
          company: data.company,
        },
      });
      this.sendMailSuccessful = true;
    },

    closeSendMailModal() {
      this.$emit("dismissModals");
      this.sendMailSuccessful = false;
    },

    switchTab(stage) {
      this.currentTab = stage;
    },

    alert(message) {
      alert(message);
    },

    getCriticalErrors() {
      return this.auditData.moonpullErrors.filter(
        (err) =>
          err.handoverImpactValue >=
          this.platformContent.handoverImpactThresholdCritical
      );
    },

    getWarningErrors() {
      return this.auditData.moonpullErrors.filter(
        (err) =>
          err.handoverImpactValue <
            this.platformContent.handoverImpactThresholdCritical &&
          err.handoverImpactValue >=
            this.platformContent.handoverImpactThresholdWarning
      );
    },

    getNoticeErrors() {
      return this.auditData.moonpullErrors.filter(
        (err) =>
          err.handoverImpactValue <
          this.platformContent.handoverImpactThresholdWarning
      );
    },

    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    toggleAuditReports() {
      this.showDropdown1 = !this.showDropdown1;
    },

    toggleMoreDetailsForError(id) {
      const err = this.moreDetailsForErrors.find((err) => err.id === id);
      if (err) {
        err.moreDetails = !err.moreDetails;
      }
    },

    getReadableMemoryCookieStatus(memoryCookieStatus) {
      switch (memoryCookieStatus) {
        case "IMMEDIATE":
          return "Cookie appears immediately";
        case "CONDITIONAL_ON_CMP":
          return "Cookie on user consent";
        case "CONDITIONAL_ON_CMP_AND_REFRESH":
          return "Cookie with consent and refresh";
        case "NO_MEMORY_COOKIE":
          return "Cookie not found";
        case "CLOSED_ADVERTISER":
          return "Closed advertiser";
        case "MANUAL_REVIEW":
          return "Manual review";
        case "NOT_AUDITED":
          return "Not audited";
        case "OTHER":
          return "Other";
        default:
          return "Unknown";
      }
    },

    getAuditMemoryCookieStatusLabel(status) {
      if (status === "IMMEDIATE") return "badge badge-primary";
      else if (status === "CONDITIONAL_ON_CMP") return "badge badge-warning";
      else if (status === "CONDITIONAL_ON_CMP_AND_REFRESH")
        return "badge badge-warning";
      else if (status === "NO_MEMORY_COOKIE") return "badge badge-danger";
      else if (status === "CLOSED_ADVERTISER") return "badge badge-secondary";
      else if (status === "NOT_AUDITED") return "badge badge-secondary";
      else if (status === "MANUAL_REVIEW") return "badge badge-secondary";
      else if (status === "OTHER") return "badge badge-secondary";

      return "badge badge-secondary";
    },

    getTrackingMatrix(audit) {
      if (
        audit.memoryCookieStatus === "MANUAL_REVIEW" ||
        audit.memoryCookieStatus === "CLOSED_ADVERTISER"
      ) {
        return ""; // Return an empty string for specified audit statuses
      }

      const stages = [
        { name: "alp", flag: "hasAlp" },
        { name: "alp-post-consent", flag: "hasAlpPostConsent" },
        { name: "alp-post-consent-refresh", flag: "hasAlpPostConsentRefresh" },
      ];

      const errorStatuses = stages.map(({ name, flag }) => {
        // Check if the audit has the stage based on the flag
        if (!audit[flag]) {
          return ""; // Skip processing if the audit does not have this stage
        }

        const errorPrefix =
          name === "alp"
            ? "5"
            : name === "alp-post-consent"
            ? "6"
            : name === "alp-post-consent-refresh"
            ? "7"
            : null;

        if (!errorPrefix || !audit.moonpullErrors) {
          return "N/A";
        }

        const networkErrors = this.networkErrorCodes.find(
          (n) => n.network === audit.network
        );
        const isErrorPresent = (errorCode) =>
          audit.moonpullErrors.find(
            (e) => e.moonpullErrorId === `${errorPrefix}.${errorCode}`
          );

        const statusForErrorCode3 =
          networkErrors && networkErrors.errorCodes.includes(`${errorPrefix}.3`)
            ? isErrorPresent("3")
              ? "N"
              : "OK"
            : "N/A";
        const statusForErrorCode4 =
          audit.cmpId === null && errorPrefix !== "5"
            ? "-"
            : isErrorPresent("4")
            ? "N"
            : "OK";
        const statusForErrorCode5 =
          (audit.cmpId === null && errorPrefix !== "5") || isErrorPresent("4")
            ? "-"
            : isErrorPresent("5")
            ? "N"
            : "OK";

        const statusForErrorCodes = [
          statusForErrorCode3,
          statusForErrorCode4,
          statusForErrorCode5,
        ].join(" ");

        // For simplicity, this example just returns the status for error code 3.
        // Adjust your logic here if you need to check for stage applicability based on audit properties.
        return statusForErrorCodes;
      });

      // Filter out empty strings to avoid displaying them, if necessary.
      return errorStatuses.filter((status) => status !== "").join(" ");
    },

    showMoreDetailsForError(id) {
      const err = this.moreDetailsForErrors.find((err) => err.id === id);
      if (err) {
        return err.moreDetails;
      }
      return false;
    },

    wasCMPDetected() {
      return !!this.auditData.moonpullErrors.find(
        (e) => e.moonpullErrorId === "5.8.1"
      );
    },

    getHandoverImpactLabel(stage) {
      if (this.auditData.manualReviewRequired) {
        return "secondary";
      }
      if (this.auditData.status === "FAILED") {
        return "secondary";
      }

      const handoverImpact =
        stage === "alp"
          ? this.auditData.handoverImpact
          : stage === "alp-post-consent"
          ? this.auditData.handoverImpactPostConsent
          : stage === "alp-post-consent-refresh"
          ? this.auditData.handoverImpactPostConsentRefresh
          : null;

      if (isNaN(handoverImpact)) {
        return "badge-secondary";
      } else if (
        handoverImpact >= this.platformContent.handoverImpactThresholdCritical
      ) {
        return "badge-danger";
      } else if (
        handoverImpact >= this.platformContent.handoverImpactThresholdWarning
      ) {
        return "badge-warning";
      }
      return "badge-primary";
    },

    requestMoonpullInvestigation() {
      console.log("requesting,...");
    },

    async addComment() {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation($auditId: ID!, $clientComment: String!) {
              auditUpdateById(
                id: $auditId
                record: { clientComment: $clientComment }
              ) {
                id
              }
            }
          `,
          variables: {
            auditId: this.auditData.id,
            clientComment: this.auditData.clientComment,
          },
        });
        // Code here will run after the comment is saved
        this.$emit("dismissModals");
        // You can add more actions here that should occur after saving the comment
      } catch (error) {
        // Handle any errors that occur during the save operation
        console.error("Error saving comment:", error);
      }
    },

    addMoonpullComment() {
      this.$apollo.mutate({
        mutation: gql`
          mutation($auditId: ID!, $moonpullComment: String!) {
            auditUpdateById(
              id: $auditId
              record: { moonpullComment: $moonpullComment }
            ) {
              id
            }
          }
        `,
        variables: {
          auditId: this.auditData.id,
          moonpullComment: this.auditData.moonpullComment,
        },
      });
      this.$emit("dismissModals");
    },

    updateAuditCausesMutation(gql) {
      return gql`
        mutation($auditId: ID!, $causeId1: ID, $causeId2: ID, $causeId3: ID) {
          auditUpdateCauses(
            auditId: $auditId
            causeId1: $causeId1
            causeId2: $causeId2
            causeId3: $causeId3
          )
        }
      `;
    },

    getUpdateAuditCausesMutationVariables() {
      return {
        auditId: this.auditData.id,
        causeId1: this.auditData.causes[0] && this.auditData.causes[0].id,
        causeId2: this.auditData.causes[1] && this.auditData.causes[1].id,
        causeId3: this.auditData.causes[2] && this.auditData.causes[2].id,
      };
    },

    updateAuditCausesMutationSuccess() {
      this.causesSavedSuccessfully = true;
      setTimeout(() => (this.causesSavedSuccessfully = false), 1500);
    },

    getAlpDomain(audit) {
      let alp;
      if (
        audit.journey &&
        Array.isArray(audit.journey) &&
        (alp = audit.journey.find((j) => j.stage === "alp"))
      ) {
        return new URL(alp.url).hostname;
      }
      return "None found";
    },

    hasAlpPostConsent() {
      return !!this.auditData.journey.find(
        (j) => j.stage === "alp-post-consent"
      );
    },

    hasAlpPostConsentRefresh() {
      return !!this.auditData.journey.find(
        (j) => j.stage === "alp-post-consent-refresh"
      );
    },

    getErrorStatusesForStage(stage) {
      const errorPrefix =
        stage === "alp"
          ? "5"
          : stage === "alp-post-consent"
          ? "6"
          : stage === "alp-post-consent-refresh"
          ? "7"
          : null;

      if (!errorPrefix || !this.auditData.moonpullErrors) {
        return "N/A";
      }
      const networkErrors = this.networkErrorCodes.find(
        (n) => n.network === this.auditData.network
      );
      return `
        ${
          networkErrors && networkErrors.errorCodes.includes(`${errorPrefix}.3`)
            ? this.auditData.moonpullErrors.find(
                (e) => e.moonpullErrorId === `${errorPrefix}.3`
              )
              ? "N"
              : "OK"
            : "N/A"
        }
        <strong>${
          this.auditData.cmpId === null && errorPrefix !== "5"
            ? "-"
            : this.auditData.moonpullErrors.find(
                (e) => e.moonpullErrorId === `${errorPrefix}.4`
              )
            ? "N"
            : "OK"
        }</strong>
        ${
          (this.auditData.cmpId === null && errorPrefix !== "5") ||
          this.auditData.moonpullErrors.find(
            (e) => e.moonpullErrorId === `${errorPrefix}.4`
          )
            ? "-"
            : this.auditData.moonpullErrors.find(
                (e) => e.moonpullErrorId === `${errorPrefix}.5`
              )
            ? "N"
            : "OK"
        }
      `;
    },

    wasThirdPartyDetected() {
      if (this.auditData.network === "Webgains") {
        return "3rd party tracking not evaluated";
      } else if (
        !this.auditData.moonpullErrors.find(
          (e) => e.moonpullErrorId === "2.1"
        ) ||
        !this.auditData.moonpullErrors.find(
          (e) =>
            e.moonpullErrorId === "2.2" ||
            !this.auditData.moonpullErrors.find(
              (e) => e.moonpullErrorId === "3.2"
            ) ||
            !this.auditData.moonpullErrors.find(
              (e) => e.moonpullErrorId === "3.3"
            )
        )
      ) {
        return "3rd party tracking present";
      } else {
        return "3rd party tracking not present";
      }
    },

    canViewFlashes() {
      return this.$moonpull.currentUserHasAccessTo("flashes");
    },

    getTrackingLikelihood(stage) {
      if (this.auditData.manualReviewRequired) {
        return "MR";
      } else if (this.auditData.status === "FAILED") {
        return "NA";
      }

      const handoverImpact =
        stage === "alp"
          ? this.auditData.handoverImpact
          : stage === "alp-post-consent"
          ? this.auditData.handoverImpactPostConsent
          : stage === "alp-post-consent-refresh"
          ? this.auditData.handoverImpactPostConsentRefresh
          : null;

      if (isNaN(handoverImpact)) {
        return "Unknown";
      }
      return Math.max(0, 100 - handoverImpact);
    },

    getErrorsInOrder(stage) {
      if (this.isUnsupportedNetwork) {
        return [];
      }

      const criticalErrors = this.getCriticalErrors();
      const warningErrors = this.getWarningErrors();
      const noticeErrors = this.getNoticeErrors();
      const allSortedErrors = [
        ...noticeErrors
          .filter(
            (err) => err.moonpullErrorId.startsWith("10") && stage === "alp"
          )
          .map((err) => ({ ...err, notice: true })),

        ...criticalErrors
          .filter((err) =>
            stage === "alp"
              ? !err.moonpullErrorId.startsWith("6") &&
                !err.moonpullErrorId.startsWith("7")
              : err.moonpullErrorId.startsWith(
                  stage === "alp-post-consent" ? "6" : "7"
                )
          )
          .map((err) => ({ ...err, critical: true })),

        ...warningErrors
          .filter((err) =>
            stage === "alp"
              ? !err.moonpullErrorId.startsWith("6") &&
                !err.moonpullErrorId.startsWith("7")
              : err.moonpullErrorId.startsWith(
                  stage === "alp-post-consent" ? "6" : "7"
                )
          )
          .map((err) => ({ ...err, warning: true })),

        ...noticeErrors
          .filter(
            (err) =>
              (stage === "alp"
                ? !err.moonpullErrorId.startsWith("6") &&
                  !err.moonpullErrorId.startsWith("7")
                : err.moonpullErrorId.startsWith(
                    stage === "alp-post-consent" ? "6" : "7"
                  )) &&
              !err.moonpullErrorId.startsWith("10.") &&
              err.moonpullErrorId !== "5.8.1" &&
              err.moonpullErrorId !== "5.8.2"
          )
          .map((err) => ({ ...err, notice: true })),
      ];
      return allSortedErrors.filter(
        (error) =>
          this.showPublisherErrors || !error.moonpullErrorId.startsWith("1.")
      );
    },

    generateScreenshotUrl(key) {
      return `https://d30bc2nkwjetgt.cloudfront.net/${key}`;
    },

    getCurrentScreenshot(stage) {
      const screenshot = this.auditData.screenshots.find(
        (s) => s.stage === stage
      );
      if (!screenshot) {
        return "None found";
      }
      return this.generateScreenshotUrl(screenshot.screenshotUrl);
    },

    getCurrentScreenshotTimestamp(stage) {
      const screenshot = this.auditData.screenshots.find(
        (s) => s.stage === stage
      );
      if (!screenshot) {
        return "";
      }
      return dateFormat(screenshot.createdAt, "ddd dS mmm yyyy, HH:MM:ss Z");
    },

    getCurrentScreenshotByteSize(stage) {
      const screenshot = this.auditData.screenshots.find(
        (s) => s.stage === stage
      );
      return (screenshot && screenshot.byteSize) || 0;
    },

    toggleFullscreenScreenshot(stage) {
      const screenshot = this.auditData.screenshots.find(
        (s) => s.stage === stage
      );
      this.currentFullScreenshotStage = stage;
      if (screenshot) {
        this.showFullscreenScreenshot = true;
        this.fullscreenScreenshot = this.generateScreenshotUrl(
          screenshot.screenshotUrl
        );
      }
    },

    getCookieStatusAcrossStages(audit) {
      if (!audit.moonpullErrors || audit.moonpullErrors.length === 0) {
        return "YY";
      }
      return `${
        audit.moonpullErrors.find((e) => e.moonpullErrorId === "5.4")
          ? "N"
          : "Y"
      }${
        audit.moonpullErrors.find((e) => e.moonpullErrorId === "6.4")
          ? "N"
          : "Y"
      }`;
    },

    queryAuditsFilterByLink(gql) {
      return gql`
        query AuditsFilterByLink($link: String!) {
          auditMany(
            filter: {
              link: { equals: $link }
              supersededById: { isNull: true }
            }
            sort: { auditedAt: DESC }
          ) {
            items {
              id
              batch {
                id
                name
                description
              }
              finalDomain
              link
              moonpullComment
              auditedAt
              causes {
                id
                reason
              }
              batch {
                owner {
                  name
                  email
                  company {
                    name
                  }
                }
              }
              tags
              failReason
              auditTime
              auditedAt
              network
              advertiser {
                id
                networkId
                advertiserId
                name
                domain
                primaryTrackingMethod
                trackingMethodNarrative
                javascript
                s2s
                other
                bespokeCookieValueType
                bespokeCookieName
                bespokeCookieValue
                bespokeAni
                bespokeMasterTag
                internalComment
                publicComment
              }
              inferredNetworkVariables
              moonpullErrors
              cookiesWereAccepted
              internalErrorObj
              handoverImpact
              handoverImpactPostConsent
              handoverImpactPostConsentRefresh
              hasPostConsentJourney
              hasPostConsentRefreshJourney
              closedMerchant
              outdated
              inferredS2S
              finalDomain
              csvOverrideCookieType
              csvOverrideCookieName
              csvOverrideCookieValue
              csvOverrideAni
              csvOverrideMasterTag
              aniTruncated
              interstitialNavigated
              noAccess
              proxyDetails
              manualReviewRequired
              hasAlp
              hasAlpPostConsent
              hasAlpPostConsentRefresh
              isRetry
              countryCode
              status
              memoryCookieStatus
              memoryCookieStatusReadable
            }
          }
        }
      `;
    },

    queryAuditsFilterByFinalDomain(gql) {
      return gql`
        query AuditsFilterByFinalDomain($finalDomain: String!) {
          auditMany(
            filter: {
              finalDomain: { equals: $finalDomain }
              supersededById: { isNull: true }
            }
            sort: { auditedAt: DESC }
          ) {
            items {
              id
              batch {
                id
                name
                description
                queueLetter
              }
              finalDomain
              link
              moonpullComment
              auditedAt
              causes {
                id
                reason
              }
              batch {
                owner {
                  name
                  email
                  company {
                    name
                  }
                }
              }
              tags
              failReason
              auditTime
              auditedAt
              network
              advertiser {
                id
                networkId
                advertiserId
                name
                domain
                primaryTrackingMethod
                trackingMethodNarrative
                javascript
                s2s
                other
                bespokeCookieValueType
                bespokeCookieName
                bespokeCookieValue
                bespokeAni
                bespokeMasterTag
                internalComment
                publicComment
              }
              inferredNetworkVariables
              moonpullErrors
              cookiesWereAccepted
              internalErrorObj
              handoverImpact
              handoverImpactPostConsent
              handoverImpactPostConsentRefresh
              hasPostConsentJourney
              hasPostConsentRefreshJourney
              closedMerchant
              outdated
              inferredS2S
              finalDomain
              csvOverrideCookieType
              csvOverrideCookieName
              csvOverrideCookieValue
              csvOverrideAni
              csvOverrideMasterTag
              aniTruncated
              interstitialNavigated
              noAccess
              proxyDetails
              manualReviewRequired
              hasAlp
              hasAlpPostConsent
              hasAlpPostConsentRefresh
              isRetry
              status
              memoryCookieStatus
              memoryCookieStatusReadable
            }
          }
        }
      `;
    },

    async copyMetadata(audit, record) {
      this.copyingMetadataLoading = true;
      await this.$apollo.mutate({
        mutation: gql`
          mutation AuditUpdateMetadata(
            $auditId: ID!
            $record: AuditUpdateInput!
          ) {
            auditUpdateById(id: $auditId, record: $record) {
              id
            }
          }
        `,
        variables: {
          auditId: this.auditData.id,
          record,
        },
      });
      for (const [key] of Object.entries(record)) {
        this.auditData[key] = audit[key];
      }
      this.copyingMetadataLoading = false;
    },

    async downloadAuditOverviewReport() {
      this.downloadingAuditOverviewReport = true;
      const domain = this.auditData.finalDomain
        .replace("www.", "")
        .split(".")
        .join("-");
      this.$moonpull.downloadFile(
        "application/pdf",
        `Moonpull-Audit-Report-${domain}-${this.dateFormat(
          new Date(this.auditData.auditedAt),
          "yyyy-mm-dd"
        )}.pdf`,
        await this.$moonpull.getOutputReportPDF(this.auditData.id)
      );
      this.downloadingAuditOverviewReport = false;

      analytics.track("Overview Report", {
        "Audit ID": `https://app.mnpll.com/#/reporting/audits/${this.auditData.id}/output-report`,
        Advertiser:
          this.auditData.finalDomain ||
          this.auditData.advertiser.domain ||
          this.auditData.advertiser.name,
      });
    },

    async downloadValueCalc() {
      try {
        console.log(
          "Downloading value calc with the following data:",
          this.data
        );
        this.downloadingValueCalc = true; // ✅ Correct this context

        const mergedData = {
          ...this.data, // Base data
          ...this.auditData, // Overwrite any conflicting fields
        };
        const domain = this.auditData.finalDomain
          .replace("www.", "")
          .split(".")
          .join("-");
        const fileName = `Moonpull-Value-Calculator-${domain}-${this.dateFormat(
          new Date(this.auditData.auditedAt),
          "yyyy-mm-dd"
        )}.pdf`;

        const pdfBuffer = await this.$moonpull.getValueCalc(mergedData);

        this.$moonpull.downloadFile("application/pdf", fileName, pdfBuffer);
      } catch (error) {
        console.error("Error downloading the PDF:", error);
      } finally {
        this.downloadingValueCalc = false; // ✅ Correct context
      }
    },

    async downloadWarningScenarioCalc() {
      try {
        console.log(
          "Downloading value calc with the following data:",
          this.data
        );
        this.downloadingWarningCalc = true; // ✅ Correct this context

        const mergedData = {
          ...this.data, // Base data
          ...this.auditData, // Overwrite any conflicting fields
        };
        const domain = this.auditData.finalDomain
          .replace("www.", "")
          .split(".")
          .join("-");
        const fileName = `Moonpull-Value-Calculator-${domain}-${this.dateFormat(
          new Date(this.auditData.auditedAt),
          "yyyy-mm-dd"
        )}.pdf`;

        const pdfBuffer = await this.$moonpull.getWarningScenarioCalc(
          mergedData
        );

        this.$moonpull.downloadFile("application/pdf", fileName, pdfBuffer);
      } catch (error) {
        console.error("Error downloading the PDF:", error);
      } finally {
        this.downloadingWarningCalc = false; // ✅ Correct context
      }
    },

    handleFormSubmit() {
      this.downloadAuditOverviewReport();
      this.notifyCSAuditReport();
    },

    // Returns true (and shows the "rerun via Callisto" modal) when the audit is
    // too old to download a report. Callers should bail out when this is true.
    // Superadmins bypass the age restriction and can always download.
    blockReportIfAuditIsOld() {
      if (this.$moonpull.currentUserIsSuperAdmin()) return false;
      if (this.isAuditOlderThanSevenDays) {
        this.showOldAuditModal = true;
        return true;
      }
      return false;
    },

    showButton(type) {
      const status =
        this.auditData.injectedResult?.template.status ||
        this.auditData.enhancedMemoryCookieStatuses?.[0]?.status ||
        this.auditData.memoryCookieStatus;
      switch (type) {
        case "consentAndRefresh":
          // Show if memoryCookieStatus is 'CONDITIONAL_ON_CMP_AND_REFRESH'
          return status === "CONDITIONAL_ON_CMP_AND_REFRESH";
        case "noAni":
          // error code scenario 4.2.1 or 5.2.1
          return this.auditData?.moonpullErrors?.find(
            (moonpullErrors) =>
              moonpullErrors.moonpullErrorId === "4.2.1" ||
              moonpullErrors.moonpullErrorId === "5.2.1"
          );
        case "noCookie":
          // Show if memoryCookieStatus is 'NO_MEMORY_COOKIE'
          return status === "NO_MEMORY_COOKIE";
        case "consentOnly":
          // Show if memoryCookieStatus is 'CONDITIONAL_ON_CMP'
          return status === "CONDITIONAL_ON_CMP";
        case "immediate":
          // Show if memoryCookieStatus is 'IMMEDIATE'
          return status === "IMMEDIATE";
        default:
          return false;
      }
    },

    async downloadTrackingStatusReport() {
      this.downloadingTrackingStatusReport = true;
      await this.addComment();
      const domain = this.auditData.finalDomain
        .replace("www.", "")
        .split(".")
        .join("-");
      this.$moonpull.downloadFile(
        "application/pdf",
        `Advertiser-Tracking-Status-Report-${domain}-${this.dateFormat(
          new Date(this.auditData.auditedAt),
          "yyyy-mm-dd"
        )}.pdf`,
        await this.$moonpull.getAdvertiserTrackingStatusPDF(this.auditData.id)
      );
      this.downloadingTrackingStatusReport = false;

      analytics.track("Overview ATSR Report", {});
    },

    async downloadImmediateReport() {
      if (this.blockReportIfAuditIsOld()) return;
      this.downloadingImmediateReport = true;
      const domain = this.auditData.finalDomain
        .replace("www.", "")
        .split(".")
        .join("-");
      this.$moonpull.downloadFile(
        "application/pdf",
        `Moonpull-Immediate-Report-${domain}-${this.dateFormat(
          new Date(this.auditData.auditedAt),
          "yyyy-mm-dd"
        )}.pdf`,
        await this.$moonpull.getImmediatePDF(this.auditData.id)
      );
      this.downloadingImmediateReport = false;
      this.notifyCSAuditReport();
    },

    async downloadConsentOnlyReport() {
      if (this.blockReportIfAuditIsOld()) return;
      this.downloadingConsentOnlyReport = true;
      const domain = this.auditData.finalDomain
        .replace("www.", "")
        .split(".")
        .join("-");
      this.$moonpull.downloadFile(
        "application/pdf",
        `Moonpull-Consent-Only-Report-${domain}-${this.dateFormat(
          new Date(this.auditData.auditedAt),
          "yyyy-mm-dd"
        )}.pdf`,
        await this.$moonpull.getConsentOnlyPDF(this.auditData.id)
      );
      this.downloadingConsentOnlyReport = false;
      this.notifyCSAuditReport();
    },

    async downloadNoCookieReport() {
      if (this.blockReportIfAuditIsOld()) return;
      this.downloadingNoCookieReport = true;
      const domain = this.auditData.finalDomain
        .replace("www.", "")
        .split(".")
        .join("-");
      this.$moonpull.downloadFile(
        "application/pdf",
        `Moonpull-No-Cookie-Report-${domain}-${this.dateFormat(
          new Date(this.auditData.auditedAt),
          "yyyy-mm-dd"
        )}.pdf`,
        await this.$moonpull.getNoCookiePDF(this.auditData.id)
      );
      this.notifyCSAuditReport();
    },

    async downloadNoAniReport() {
      if (this.blockReportIfAuditIsOld()) return;
      this.downloadingNoCookieReport = true;
      const domain = this.auditData.finalDomain
        .replace("www.", "")
        .split(".")
        .join("-");
      this.$moonpull.downloadFile(
        "application/pdf",
        `Moonpull-No-ani-Report-${domain}-${this.dateFormat(
          new Date(this.auditData.auditedAt),
          "yyyy-mm-dd"
        )}.pdf`,
        await this.$moonpull.getNoAniPDF(this.auditData.id)
      );
      this.notifyCSAuditReport();
    },

    async downloadConsentAndRefreshReport() {
      if (this.blockReportIfAuditIsOld()) return;
      this.downloadingNoCookieReport = true;
      const domain = this.auditData.finalDomain
        .replace("www.", "")
        .split(".")
        .join("-");
      this.$moonpull.downloadFile(
        "application/pdf",
        `Moonpull-Consent-Refresh-Report-${domain}-${this.dateFormat(
          new Date(this.auditData.auditedAt),
          "yyyy-mm-dd"
        )}.pdf`,
        await this.$moonpull.getUserConsentRefreshPDF(this.auditData.id)
      );
      this.notifyCSAuditReport();
    },

    async submitConsentAnalysis() {
      let advertiserHome = this.auditData.finalDomain;
      if (!advertiserHome) {
        function getAdvertiserHomeFromUser() {
          try {
            const input = prompt(
              `Moonpull could not automatically detect the advertiser's home URL. ` +
                `Please enter the Advertiser's Home URL including "http(s)://""`
            );

            // User cancelled the action
            if (!input) {
              return;
            }

            const validUrl = new URL(input);
            advertiserHome = validUrl.href;
          } catch (e) {
            alert(
              `Please make sure you input a valid URL including "http(s)://"`
            );
            getAdvertiserHomeFromUser();
          }
        }

        getAdvertiserHomeFromUser();

        // User cancelled the request
        if (!advertiserHome) {
          alert(
            `Advertiser home URL was not provided. Consent Checker was not submitted.`
          );
          return;
        }
      }

      // Map audit data to the expected format
      const data = {
        userDefinedNetwork: this.auditData.batchLink.userDefinedNetwork,
        link: this.auditData.batchLink.link,
        cookieName: this.auditData.batchLink.cookieName,
        cookieType: this.auditData.batchLink.cookieType,
        customAni: this.auditData.batchLink.customAni,
        customMasterTag: this.auditData.batchLink.customMasterTag,
        countryCode: this.auditData.batchLink.countryCode,
        advertiserHome: `https://${this.auditData.finalDomain}`,
      };

      this.loading = true;

      // Create audits based on consent analysis scenario from the mapped data
      const audits = createConsentAnalysisScenario("default", data);

      // Call the audit function with mapped data fields
      const newBatch = await this.$moonpull.audit(audits, {
        name: getAdvertiserName(this.auditData),
        description: "Memory cookie - Refresh or Navigate appraisal",
        queueLetter: this.auditData.batch.queueLetter,
        notifyOnComplete: true,
        useLite: false,
      });

      // Redirect if batch created successfully
      if (newBatch) {
        this.$router.push({
          name: "reporting-batches",
          query: { newBatch: newBatch.batchId },
        });
      }

      this.loading = false;
    },

    async submitLinkMultipleTimes(data) {
      this.loadingMultipleLinkSubmission = true;

      await this.$apollo.mutate({
        mutation: gql`
          mutation($numRuns: Float!, $auditId: ID!, $delay: Float) {
            submitLinkMultipleTimes(
              numRuns: $numRuns
              auditId: $auditId
              delay: $delay
            )
          }
        `,
        variables: {
          numRuns: data.numRuns,
          delay: Number(data.delay) || 3600,
          auditId: this.$route.params.auditId,
        },
      });
      this.loadingMultipleLinkSubmission = false;
      this.$emit("dismissModals");
      this.$store.dispatch("flashMessage", {
        type: "success",
        msg:
          "Link(s) have been queued successfully. Please note: They may take a minute or so to be commenced so will not necessarily appear immediately in the ‘Your Results’ table.",
      });
    },

    yourAuditNavigation() {
      this.$router.push({
        path: "/reporting/audits",
        query: { filter: `${getAdvertiserName(this.auditData)}` },
      });
    },

    async rerunLinkAndBrowserExtension() {
      try {
        // Start the browser extension/local memory cookie check
        await this.localMemoryCookieCheck();

        // Submit the link with numRuns set to 1
        await this.submitLinkMultipleTimes({
          numRuns: 1,
        });
      } catch (e) {
        console.error("Error in rerunLinkAndBrowserExtension:", e);
        this.$store.dispatch("flashMessage", {
          type: "danger",
          msg:
            "There was an error while rerunning the link and triggering the browser extension.",
        });
      }
    },
  },

  async mounted() {
    this.view = this.$route.params.view;
    this.networkSpecificComments = await this.$moonpull.getNetworksComments();
    this.platformContent = await this.$moonpull.getPlatformContent();
    this.networks = await this.$moonpull.getNetworks();
    this.networkErrorCodes = this.networks.map((network) => {
      const errorCodes = [];
      const stages = [
        "niu",
        "nir",
        "air",
        "alp",
        "alp-post-consent",
        "alp-post-consent-refresh",
      ];
      stages.forEach((stage) => {
        if (network.successCriteria[stage]) {
          if (network.successCriteria[stage].query) {
            errorCodes.push(
              ...network.successCriteria[stage].query
                .map((q) => [
                  q.moonpullErrorCodeForKey,
                  q.moonpullErrorCodeForValue,
                ])
                .flat()
            );
          }
          if (network.successCriteria[stage].cookies) {
            errorCodes.push(
              ...network.successCriteria[stage].cookies
                .map((q) => [
                  q.moonpullErrorCodeForKey,
                  q.moonpullErrorCodeForValue,
                ])
                .flat()
            );
          }
          if (network.successCriteria[stage].scripts) {
            errorCodes.push(
              ...network.successCriteria[stage].scripts.map(
                (q) => q.moonpullErrorCode
              )
            );
          }
          if (network.successCriteria[stage].extracted) {
            errorCodes.push(
              ...network.successCriteria[stage].extracted.map(
                (q) => q.moonpullErrorCode
              )
            );
          }
        }
      });

      return {
        network: network.name,
        errorCodes,
      };
    });

    // Show first error if there are less than 3
    // I don't know why this makes an error :)
    try {
      const alpErrors = this.getErrorsInOrder("alp");
      if (alpErrors.length > 0 && alpErrors.length < 3) {
        this.toggleMoreDetailsForError(alpErrors[0].moonpullErrorId);
      }

      const alpPostConsentErrors = this.getErrorsInOrder("alp-post-consent");
      if (alpPostConsentErrors.length > 0 && alpPostConsentErrors.length < 3) {
        this.toggleMoreDetailsForError(alpPostConsentErrors[0].moonpullErrorId);
      }

      const alpPostConsentRefreshErrors = this.getErrorsInOrder(
        "alp-post-consent-refresh"
      );
      if (
        alpPostConsentRefreshErrors.length > 0 &&
        alpPostConsentRefreshErrors.length < 3
      ) {
        this.toggleMoreDetailsForError(
          alpPostConsentRefreshErrors[0].moonpullErrorId
        );
      }
    } catch (e) {}
    if (this.$route.query.pdfView === "1" && !this.pdfPrinted) {
      this.pdfPrinted = true;
      this.printPDF();
    }

    this.loading = false;
  },

  async beforeCreate() {
    await this.$moonpull.redirectToNewAuditIdIfNecessary(
      this.$route.params.auditId,
      "report-detail-output"
    );
    analytics.page(" view", {
      path: window.location.hash,
      referrer: window.location.hash,
    });
  },
});
</script>
